/**
 * Boopr Pet Account — Client JS (v2: Multi-pet + UX fixes)
 * Handles: API client, wizard, pet dashboard, product badges, calculator auto-fill
 */
(function () {
  'use strict';

  var API_BASE = 'https://api.boopr.ro/accounts';
  var CACHE_TTL = 5 * 60 * 1000; // 5 min

  // Cache keys scoped per customer to prevent data leaks between accounts
  function cacheKey(base) {
    var auth = window.__booprAuth;
    var cid = auth ? auth.cid : 'anon';
    return base + '_' + cid;
  }
  var CACHE_KEY = 'boopr_pet_profile';  // legacy, not used much
  var CACHE_PETS_KEY = 'boopr_pets';
  var CACHE_OWNER_KEY = 'boopr_owner_profile';

  // ── Breed icon mapping ──────────────────────────────────────────────────
  var BREED_ICONS = {
    'labrador-retriever': 'breed-icon-labrador.svg',
    'labrador': 'breed-icon-labrador.svg',
    'golden-retriever': 'breed-icon-golden-retriever.svg',
    'german-shepherd': 'breed-icon-german-shepherd.svg',
    'ciobanesc-german': 'breed-icon-german-shepherd.svg',
    'french-bulldog': 'breed-icon-french-bulldog.svg',
    'bulldog-francez': 'breed-icon-french-bulldog.svg',
    'bulldog': 'breed-icon-bulldog.svg',
    'poodle': 'breed-icon-poodle.svg',
    'caniche': 'breed-icon-poodle.svg',
    'beagle': 'breed-icon-beagle.svg',
    'rottweiler': 'breed-icon-rottweiler.svg',
    'dachshund': 'breed-icon-dachshund.svg',
    'teckel': 'breed-icon-dachshund.svg',
    'boxer': 'breed-icon-boxer.svg',
    'siberian-husky': 'breed-icon-husky.svg',
    'husky': 'breed-icon-husky.svg',
    'yorkshire-terrier': 'breed-icon-yorkshire.svg',
    'yorkshire': 'breed-icon-yorkshire.svg',
    'doberman': 'breed-icon-doberman.svg',
    'great-dane': 'breed-icon-great-dane.svg',
    'dog-german': 'breed-icon-great-dane.svg',
    'shih-tzu': 'breed-icon-shih-tzu.svg',
    'border-collie': 'breed-icon-border-collie.svg',
    'australian-shepherd': 'breed-icon-australian-shepherd.svg',
    'cocker-spaniel': 'breed-icon-cocker-spaniel.svg',
    'cavalier-king-charles': 'breed-icon-cavalier.svg',
    'pomeranian': 'breed-icon-pomeranian.svg',
    'chihuahua': 'breed-icon-chihuahua.svg',
    'jack-russell': 'breed-icon-jack-russell.svg',
    'jack-russell-terrier': 'breed-icon-jack-russell.svg',
    'maltese': 'breed-icon-maltese.svg',
    'bichon': 'breed-icon-bichon.svg',
    'bichon-frise': 'breed-icon-bichon.svg',
    'pug': 'breed-icon-pug.svg',
    'mops': 'breed-icon-pug.svg',
    'akita': 'breed-icon-akita.svg',
    'akita-inu': 'breed-icon-akita.svg',
    'shiba-inu': 'breed-icon-shiba.svg',
    'shiba': 'breed-icon-shiba.svg',
    'bernese-mountain-dog': 'breed-icon-bernese.svg',
    'ciobanesc-bernez': 'breed-icon-bernese.svg',
    'dalmatian': 'breed-icon-dalmatian.svg',
    'weimaraner': 'breed-icon-weimaraner.svg',
    'vizsla': 'breed-icon-vizsla.svg',
    'cane-corso': 'breed-icon-cane-corso.svg',
    'pit-bull': 'breed-icon-pitbull.svg',
    'american-pit-bull': 'breed-icon-pitbull.svg',
    'staffordshire': 'breed-icon-pitbull.svg',
    'amstaff': 'breed-icon-pitbull.svg',
    'german-shorthaired-pointer': 'breed-icon-pointer.svg',
    'pointer': 'breed-icon-pointer.svg',
    'schnauzer': 'breed-icon-schnauzer.svg',
    'west-highland': 'breed-icon-westie.svg',
    'westie': 'breed-icon-westie.svg',
    'shar-pei': 'breed-icon-shar-pei.svg',
    'saint-bernard': 'breed-icon-saint-bernard.svg',
    'newfoundland': 'breed-icon-newfoundland.svg',
    'samoyed': 'breed-icon-samoyed.svg',
    'malinois': 'breed-icon-malinois.svg',
    'belgian-malinois': 'breed-icon-malinois.svg',
    'whippet': 'breed-icon-whippet.svg',
    'greyhound': 'breed-icon-greyhound.svg',
  };

  var BREED_GROUP_FALLBACKS = [
    { keyword: 'retriever', icon: 'breed-icon-labrador.svg' },
    { keyword: 'shepherd', icon: 'breed-icon-german-shepherd.svg' },
    { keyword: 'ciobanesc', icon: 'breed-icon-german-shepherd.svg' },
    { keyword: 'terrier', icon: 'breed-icon-jack-russell.svg' },
    { keyword: 'spaniel', icon: 'breed-icon-cocker-spaniel.svg' },
    { keyword: 'bulldog', icon: 'breed-icon-bulldog.svg' },
    { keyword: 'collie', icon: 'breed-icon-border-collie.svg' },
    { keyword: 'pinscher', icon: 'breed-icon-doberman.svg' },
    { keyword: 'schnauzer', icon: 'breed-icon-schnauzer.svg' },
    { keyword: 'hound', icon: 'breed-icon-beagle.svg' },
    { keyword: 'setter', icon: 'breed-icon-pointer.svg' },
    { keyword: 'pointer', icon: 'breed-icon-pointer.svg' },
  ];

  function getBreedIconUrl(breed) {
    if (!breed) return null;
    var slug = breed.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    if (BREED_ICONS[slug]) {
      return window.Shopify && window.Shopify.cdnHost
        ? 'https://' + window.Shopify.cdnHost + '/s/files/1/0/' + BREED_ICONS[slug]
        : '/assets/' + BREED_ICONS[slug] + '?' + Date.now();
    }
    var lower = breed.toLowerCase();
    for (var i = 0; i < BREED_GROUP_FALLBACKS.length; i++) {
      if (lower.indexOf(BREED_GROUP_FALLBACKS[i].keyword) !== -1) {
        var icon = BREED_GROUP_FALLBACKS[i].icon;
        return window.Shopify && window.Shopify.cdnHost
          ? 'https://' + window.Shopify.cdnHost + '/s/files/1/0/' + icon
          : '/assets/' + icon + '?' + Date.now();
      }
    }
    return null;
  }

  // ── Auth ────────────────────────────────────────────────────────────────
  function getAuth() {
    return window.__booprAuth || null;
  }

  function authHeaders() {
    var auth = getAuth();
    if (!auth) return {};
    return {
      'X-Customer-Id': String(auth.cid),
      'X-Customer-Email': auth.email,
      'X-Customer-Token': auth.token,
    };
  }

  // ── API Client ─────────────────────────────────────────────────────────
  function api(path, opts) {
    opts = opts || {};
    var url = API_BASE + path;
    var headers = Object.assign({ 'Content-Type': 'application/json' }, authHeaders(), opts.headers || {});
    return fetch(url, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    }).then(function (r) { return r.json(); });
  }

  function apiUpload(path, formData) {
    var auth = getAuth();
    return fetch(API_BASE + path, {
      method: 'POST',
      headers: {
        'X-Customer-Id': String(auth.cid),
        'X-Customer-Email': auth.email,
        'X-Customer-Token': auth.token,
      },
      body: formData,
    }).then(function (r) { return r.json(); });
  }

  // ── Cache (scoped per customer) ────────────────────────────────────────
  function getCache(key) {
    try {
      var scopedKey = cacheKey(key);
      var raw = sessionStorage.getItem(scopedKey);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (Date.now() - cached._ts > CACHE_TTL) {
        sessionStorage.removeItem(scopedKey);
        return null;
      }
      return cached.data;
    } catch (e) { return null; }
  }

  function setCache(key, data) {
    try {
      sessionStorage.setItem(cacheKey(key), JSON.stringify({ data: data, _ts: Date.now() }));
    } catch (e) { /* ignore */ }
  }

  function clearAllCaches() {
    try {
      // Nuclear option: clear ALL boopr/bpet keys from sessionStorage
      var keysToRemove = [];
      for (var i = 0; i < sessionStorage.length; i++) {
        var k = sessionStorage.key(i);
        if (k && (k.indexOf('boopr') === 0 || k.indexOf('bpet') === 0)) {
          keysToRemove.push(k);
        }
      }
      keysToRemove.forEach(function (k) { sessionStorage.removeItem(k); });
    } catch (e) { /* ignore */ }
  }

  // ── Fetch pets (multi-pet) ─────────────────────────────────────────────
  function fetchPets(forceRefresh) {
    if (!forceRefresh) {
      var cached = getCache(CACHE_PETS_KEY);
      if (cached) return Promise.resolve(cached);
    }
    return api('/pets').then(function (data) {
      if (data.ok && data.pets) {
        setCache(CACHE_PETS_KEY, data.pets);
        return data.pets;
      }
      // Fallback: try old /pet-profile endpoint
      return api('/pet-profile').then(function (d) {
        if (d.ok && d.profile && d.profile.name) {
          var pets = [d.profile];
          setCache(CACHE_PETS_KEY, pets);
          return pets;
        }
        return [];
      });
    }).catch(function () {
      // If /pets fails entirely, try old endpoint
      return api('/pet-profile').then(function (d) {
        if (d.ok && d.profile && d.profile.name) {
          var pets = [d.profile];
          setCache(CACHE_PETS_KEY, pets);
          return pets;
        }
        return [];
      }).catch(function () { return []; });
    });
  }

  // ── Fetch owner profile ────────────────────────────────────────────────
  function fetchOwnerProfile(forceRefresh) {
    if (!forceRefresh) {
      var cached = getCache(CACHE_OWNER_KEY);
      if (cached) return Promise.resolve(cached);
    }
    return api('/customer-profile').then(function (data) {
      if (data.ok && data.profile) {
        setCache(CACHE_OWNER_KEY, data.profile);
        return data.profile;
      }
      // Fallback: read billing from old /pet-profile
      return api('/pet-profile').then(function (d) {
        if (d.ok && d.profile) {
          var p = d.profile;
          var owner = { cui: p.cui, billing_company: p.billing_company, billing_address1: p.billing_address1, billing_city: p.billing_city, billing_county: p.billing_county, billing_zip: p.billing_zip, billing_country: p.billing_country };
          setCache(CACHE_OWNER_KEY, owner);
          return owner;
        }
        return null;
      });
    }).catch(function () {
      return api('/pet-profile').then(function (d) {
        if (d.ok && d.profile) {
          var p = d.profile;
          var owner = { cui: p.cui, billing_company: p.billing_company, billing_address1: p.billing_address1, billing_city: p.billing_city, billing_county: p.billing_county, billing_zip: p.billing_zip, billing_country: p.billing_country };
          setCache(CACHE_OWNER_KEY, owner);
          return owner;
        }
        return null;
      }).catch(function () { return null; });
    });
  }

  // ── Backward compat: fetch first pet as profile ────────────────────────
  function fetchProfile(forceRefresh) {
    return fetchPets(forceRefresh).then(function (pets) {
      return pets.length > 0 ? pets[0] : null;
    });
  }

  // ── DARF products with kcal/100g values ─────────────────────────────────
  var DARF_PRODUCTS = [
    { name: 'DARF Vită', kcal: 418.4, adult: true },
    { name: 'DARF Miel', kcal: 394.5, adult: true },
    { name: 'DARF Curcan', kcal: 415, adult: true },
    { name: 'DARF Pește', kcal: 396, adult: true },
    { name: 'DARF Vânat', kcal: 394.5, adult: true },
    { name: 'DARF Iepure', kcal: 371.3, adult: true },
    { name: 'DARF Somon', kcal: 394.5, adult: true },
    { name: 'DARF Activ', kcal: 462, adult: true },
    { name: 'DARF Insect', kcal: 365, adult: true },
    { name: 'DARF Regular', kcal: 394.5, adult: true },
    { name: 'DARF Puppy', kcal: 462, puppy: true },
    { name: 'DARF Light', kcal: 292, light: true },
    { name: 'DARF Cal', kcal: 357, light: true },
    { name: 'DARF Regular Mini', kcal: 394, adult: true },
  ];

  // DARF products — real URLs + prices from boopr.ro
  // fat_pct = grăsimi brute % (valori DARF cold-pressed declarate)
  var DARF_REC_PRODUCTS = [
    { name: 'DARF Vită',        fat_pct: 12, price: 'de la 243.99 RON', allergens: ['vita', 'vaca', 'beef'],                          href: '/products/darf-vita-hrana-uscata-presata-la-rece' },
    { name: 'DARF Miel',        fat_pct: 10, price: 'de la 243.99 RON', allergens: ['miel', 'lamb'],                                  href: '/products/darf-miel-hrana-uscata-presata-la-rece' },
    { name: 'DARF Curcan',      fat_pct: 14, price: 'de la 249.99 RON', allergens: ['curcan', 'turkey'],                              href: '/products/darf-vol-curcan-hrana-uscata-presata-la-rece' },
    { name: 'DARF Somon',       fat_pct: 10, price: 'de la 242.99 RON', allergens: ['somon', 'salmon'],                               href: '/products/darf-somon-hrana-uscata-presata-la-rece' },
    { name: 'DARF Vânat',       fat_pct: 11, price: 'de la 249.99 RON', allergens: ['vanat', 'vânat', 'caprioara', 'cerb', 'iepure'], href: '/products/darf-vanat-hrana-uscata-presata-la-rece-pentru-caini' },
    { name: 'DARF Iepure',      fat_pct: 9.5, price: 'de la 249.99 RON', allergens: ['iepure', 'rabbit'],                            href: '/products/darf-iepure-hrana-uscata-presata-la-rece-pentru-caini' },
    { name: 'DARF Cal',         fat_pct: 8.3, price: 'de la 249.99 RON', allergens: ['cal', 'horse'],                             href: '/products/darf-cal-hrana-uscata-presata-la-rece-pentru-caini-1' },
    { name: 'DARF Pește',       fat_pct: 10, price: 'de la 249.99 RON', allergens: ['peste', 'fish'],                                 href: '/products/darf-peste-din-marea-nordului' },
    { name: 'DARF Light',       fat_pct:  7, price: 'de la 249.99 RON', allergens: ['vita', 'vaca'],                                  href: '/products/darf-light' },
    { name: 'DARF Activ',       fat_pct: 15, price: 'de la 249.99 RON', allergens: ['vita', 'vaca', 'beef'],                          href: '/products/darf-activ-hrana-uscata-presata-la-rece-pentru-caini-activi' },
    { name: 'DARF Insect',      fat_pct: 10, price: 'de la 249.99 RON', allergens: ['insecte', 'insect', 'larve'],                    href: '/products/darf-insect-hrana-uscata-presata-la-rece-pentru-caini' },
    { name: 'DARF Regular',     fat_pct: 10, price: '242.99 RON',        allergens: ['vita', 'vaca', 'beef'],                          href: '/products/darf-regular-hrana-uscata-presata-la-rece-pentru-caini' },
    { name: 'DARF Regular Mini',fat_pct: 12, price: '242.99 RON',        allergens: ['vita', 'miel', 'pui', 'chicken', 'lamb'],        href: '/products/darf-regular-mini-hrana-uscata-presata-la-rece' },
    { name: 'DARF Puppy',       fat_pct: 15, price: 'de la 249.99 RON', allergens: ['pui', 'vita', 'chicken'],                        href: '/products/darf-puppy' },
  ];

  // Fat limits per health condition (matches conditions:kb KV)
  var CONDITION_FAT_LIMITS = {
    pancreatita:   8,
    boli_cardiace: 10,
    hipotiroidism: 10,
    obezitate:     10,
  };

  // Predefined health conditions (mirrors pet-health-widget.js)
  var PREDEFINED_CONDITIONS = [
    { id: 'pancreatita',   label: 'Pancreatită' },
    { id: 'boala_renala',  label: 'Boală renală' },
    { id: 'diabet',        label: 'Diabet' },
    { id: 'epilepsie',     label: 'Epilepsie' },
    { id: 'hipotiroidism', label: 'Hipotiroidism' },
    { id: 'boli_cardiace', label: 'Boli cardiace' },
    { id: 'IBD',           label: 'IBD / Colon iritabil' },
    { id: 'artrita',       label: 'Artrita' },
    { id: 'displazie',     label: 'Displazie sold/cot' },
    { id: 'alergii_piele', label: 'Alergii cutanate' },
    { id: 'cushing',       label: 'Sindrom Cushing' },
    { id: 'litiaza',       label: 'Litiaza urinara' },
    { id: 'tumori',        label: 'Neoplasm / Tumora' },
  ];

  var activeConditions = []; // loaded per pet

  function clearEl(el) { while (el.firstChild) el.removeChild(el.firstChild); }

  // ── Pet segment detection ─────────────────────────────────────────────
  function petAgeMonths(dob) {
    if (!dob) return null;
    var born = new Date(dob);
    if (isNaN(born.getTime())) return null;
    var now = new Date();
    return (now.getFullYear() - born.getFullYear()) * 12 + (now.getMonth() - born.getMonth());
  }

  function isPuppy(pet) {
    var months = petAgeMonths(pet.date_of_birth);
    return months !== null && months < 10;
  }

  function isOverweight(pet) {
    return parseFloat(pet.activity_level) === 1.2;
  }

  function getDarfStorageKey(petId) {
    return 'boopr_darf_' + (petId || 'default');
  }

  // ── DARF choice is stored on the pet (current_food), localStorage is only a fallback ──
  function isDarfName(name) {
    return !!name && DARF_PRODUCTS.some(function (p) { return p.name === name; });
  }

  function findPetById(petId) {
    var list = allPets || [];
    for (var i = 0; i < list.length; i++) { if (list[i] && list[i].id === petId) return list[i]; }
    return null;
  }

  function setPetFoodLocally(petId, productName) {
    var pet = findPetById(petId);
    if (pet) pet.current_food = productName || null;
    var cached = getCache(CACHE_PETS_KEY);
    if (cached && cached.forEach) {
      cached.forEach(function (p) { if (p && p.id === petId) p.current_food = productName || null; });
      setCache(CACHE_PETS_KEY, cached);
    }
  }

  function persistDarfProduct(petId, productName) {
    if (!petId || !findPetById(petId)) return Promise.resolve(false);
    return api('/pets/' + petId, { method: 'POST', body: { current_food: productName || null } })
      .then(function (d) { return !!(d && d.ok); })
      .catch(function () { return false; });
  }

  function getSavedDarfProduct(petId) {
    var pet = findPetById(petId);
    if (pet && isDarfName(pet.current_food)) return pet.current_food;
    try { return localStorage.getItem(getDarfStorageKey(petId)) || ''; } catch (e) { return ''; }
  }

  // persist = true only for a choice the customer made (not for auto recommendations)
  function saveDarfProduct(petId, productName, persist) {
    try {
      if (productName) { localStorage.setItem(getDarfStorageKey(petId), productName); }
      else             { localStorage.removeItem(getDarfStorageKey(petId)); }
    } catch (e) { /* ignore */ }
    if (!persist) return Promise.resolve(true);
    setPetFoodLocally(petId, productName);
    return persistDarfProduct(petId, productName);
  }

  // Show a short message under the dropdown when saving to the account fails
  function showDarfSaveError(selectEl, failed) {
    if (!selectEl || !selectEl.parentNode) return;
    var msg = document.getElementById('bpet-darf-save-error');
    if (!failed) { if (msg) msg.remove(); return; }
    if (!msg) {
      msg = document.createElement('div');
      msg.id = 'bpet-darf-save-error';
      msg.style.cssText = 'margin-top:6px;font-size:13px;color:#e81c08;';
      selectEl.parentNode.insertBefore(msg, selectEl.nextSibling);
    }
    msg.textContent = 'Nu am putut salva alegerea în cont. Mai încearcă o dată.';
  }

  function getDarfKcal(productName) {
    for (var i = 0; i < DARF_PRODUCTS.length; i++) {
      if (DARF_PRODUCTS[i].name === productName) return DARF_PRODUCTS[i].kcal;
    }
    return 394; // default fallback
  }

  // ── Portion calculator ─────────────────────────────────────────────────
  function calcPortion(weight, activityLevel, mealsPerDay, kcalPer100g) {
    if (!weight || !activityLevel) return null;
    var rer = 70 * Math.pow(weight, 0.75);
    var mer = rer * activityLevel;
    var kcal = kcalPer100g || 394;
    var gramsTotal = mer / (kcal / 100);
    var gramsPerMeal = gramsTotal / (mealsPerDay || 2);
    return {
      total: Math.round(gramsTotal),
      perMeal: Math.round(gramsPerMeal),
      kcal: Math.round(mer),
      meals: mealsPerDay || 2,
      kcalPer100g: kcal,
    };
  }

  function petAge(dob) {
    if (!dob) return '';
    var born = new Date(dob);
    var now = new Date();
    var months = (now.getFullYear() - born.getFullYear()) * 12 + (now.getMonth() - born.getMonth());
    if (months < 12) return months + (months === 1 ? ' lună' : ' luni');
    var years = Math.floor(months / 12);
    var rem = months % 12;
    var s = years + (years === 1 ? ' an' : ' ani');
    if (rem > 0) s += ' și ' + rem + (rem === 1 ? ' lună' : ' luni');
    return s;
  }

  function activityLabel(level) {
    var map = {
      '1': 'Inactiv', '1.0': 'Inactiv',
      '1.2': 'Supraponderal',
      '1.4': 'Sterilizat, puțin activ',
      '1.6': 'Activ normal',
      '1.8': 'Adult activ',
      '2': 'Pui 4-12 luni', '2.0': 'Pui 4-12 luni',
      '2.5': 'Foarte activ',
      '3': 'Pui sub 4 luni', '3.0': 'Pui sub 4 luni',
    };
    return map[String(level)] || '';
  }

  // ── Pet avatar HTML helper ────────────────────────────────────────────
  function petAvatarHtml(pet, size) {
    var sz = size || 40;
    if (pet.photo_url) {
      return '<img src="' + pet.photo_url + '" alt="" style="width:' + sz + 'px!important;height:' + sz + 'px!important;min-width:' + sz + 'px!important;min-height:' + sz + 'px!important;max-width:none!important;max-height:none!important;object-fit:cover!important;display:block!important;flex-shrink:0!important;border-radius:0!important;">';
    }
    var icon = getBreedIconUrl(pet.breed);
    if (icon) {
      var iconSz = Math.round(sz * 0.6);
      return '<img src="' + icon + '" class="breed-icon" alt="' + (pet.breed || '') + '" style="width:' + iconSz + 'px;height:' + iconSz + 'px;object-fit:contain;display:block;">';
    }
    var defaultUrl = (document.querySelector('.bpet') || {}).dataset && document.querySelector('.bpet').dataset.petAvatarDefault;
    if (defaultUrl) {
      return '<img src="' + defaultUrl + '" alt="" style="width:' + sz + 'px;height:' + sz + 'px;object-fit:contain;display:block;">';
    }
    return '🐕';
  }

  // ══════════════════════════════════════════════════════════════════════
  // MULTI-PET STATE
  // ══════════════════════════════════════════════════════════════════════

  var allPets = [];
  var activePetIndex = 0;
  var ownerProfile = null;

  function getActivePet() {
    return allPets[activePetIndex] || null;
  }

  function switchTab(tabName) {
    var nav = document.getElementById('bpet-nav');
    if (!nav) return;
    nav.querySelectorAll('button[data-tab]').forEach(function(b) { b.classList.remove('active'); });
    var btn = nav.querySelector('button[data-tab="' + tabName + '"]');
    if (btn) btn.classList.add('active');
    document.querySelectorAll('.bpet-panel').forEach(function(p) { p.classList.remove('active'); });
    var panel = document.getElementById('bpet-tab-' + tabName);
    if (panel) panel.classList.add('active');
  }

  // ══════════════════════════════════════════════════════════════════════
  // PET DASHBOARD (account page)
  // ══════════════════════════════════════════════════════════════════════

  function initDashboard() {
    var nav = document.getElementById('bpet-nav');
    if (!nav) return;

    var auth = getAuth();
    if (!auth) return;

    // Detect customer change — clear stale caches from other accounts
    try {
      var lastCid = sessionStorage.getItem('boopr_last_cid');
      if (lastCid && lastCid !== String(auth.cid)) {
        // Customer changed! Nuke ALL boopr caches
        var keysToRemove = [];
        for (var i = 0; i < sessionStorage.length; i++) {
          var k = sessionStorage.key(i);
          if (k && k.indexOf('boopr') === 0 || k && k.indexOf('bpet') === 0) {
            keysToRemove.push(k);
          }
        }
        keysToRemove.forEach(function (k) { sessionStorage.removeItem(k); });
      }
      sessionStorage.setItem('boopr_last_cid', String(auth.cid));
    } catch (e) { /* ignore */ }

    // Tab navigation
    var buttons = nav.querySelectorAll('button[data-tab]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        document.querySelectorAll('.bpet-panel').forEach(function (p) { p.classList.remove('active'); });
        var panel = document.getElementById('bpet-tab-' + btn.getAttribute('data-tab'));
        if (panel) panel.classList.add('active');
        // Reload health data when switching to health tab
        if (btn.getAttribute('data-tab') === 'health') {
          var activePet = getActivePet();
          if (activePet) initHealthTab(activePet);
        }
      });
    });

    // Init UI handlers (wrapped in try-catch so they don't block data loading)
    try { initProfileEdit(); } catch (e) { console.error('[boopr] initProfileEdit error:', e); }
    try { initAddressForms(); } catch (e) { console.error('[boopr] initAddressForms error:', e); }

    // Address CRUD via Boopr API — intercept form submits + delete clicks
    (function() {
      // Intercept ALL form submits inside address containers
      document.addEventListener('submit', function(e) {
        var form = e.target;
        // New address form
        if (form.closest && form.closest('#bpet-addr-new-form')) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          _saveAddr(btn || form, form, 'POST', '/addresses');
          return;
        }
        // Edit address form
        var card = form.closest && form.closest('.bpet-addr-card');
        if (card && form.closest('.bpet-addr-form')) {
          e.preventDefault();
          var addrId = card.getAttribute('data-addr-id');
          if (addrId) {
            var btn = form.querySelector('button[type="submit"]');
            _saveAddr(btn || form, form, 'PUT', '/addresses/' + addrId);
          }
          return;
        }
      }, true); // useCapture=true to catch before native submit

      function _getAddrData(c) {
        return {
          first_name: (c.querySelector('[name="address[first_name]"]')||{}).value||'',
          last_name: (c.querySelector('[name="address[last_name]"]')||{}).value||'',
          address1: (c.querySelector('[name="address[address1]"]')||{}).value||'',
          address2: (c.querySelector('[name="address[address2]"]')||{}).value||'',
          city: (c.querySelector('[name="address[city]"]')||{}).value||'',
          province: (c.querySelector('[name="address[province]"]')||{}).value||'',
          zip: (c.querySelector('[name="address[zip]"]')||{}).value||'',
          phone: (c.querySelector('[name="address[phone]"]')||{}).value||'',
          country: (c.querySelector('[name="address[country]"]')||{}).value||'Romania',
        };
      }
      function _saveAddr(btn, container, method, apiPath) {
        var data = _getAddrData(container);
        if (!data.address1 || !data.city) { alert('Completează cel puțin adresa și orașul.'); return; }
        var origText = btn.textContent;
        btn.disabled = true; btn.textContent = 'Se salvează...';
        var a = window.__booprAuth || {};
        console.log('[Boopr] Saving address to', apiPath, data);
        fetch('https://api.boopr.ro/accounts' + apiPath, {
          method: method,
          headers: { 'Content-Type': 'application/json', 'x-customer-id': String(a.customer_id||''), 'x-customer-email': a.customer_email||'', 'x-customer-token': a.token||'' },
          body: JSON.stringify(data),
        }).then(function(r){return r.json()}).then(function(resp) {
          console.log('[Boopr] Address response:', resp);
          if (resp.ok) { sessionStorage.setItem('bpet_goto_tab','addresses'); window.location.reload(); }
          else { alert('Eroare: '+(resp.error||'necunoscută')); btn.disabled=false; btn.textContent=origText; }
        }).catch(function(e) { alert('Eroare: '+e.message); btn.disabled=false; btn.textContent=origText; });
      }
      // New address button
      var nb = document.getElementById('bpet-addr-new-save');
      if (nb) {
        console.log('[Boopr] Address save button found, attaching handler');
        nb.addEventListener('click', function() {
          _saveAddr(nb, document.getElementById('bpet-addr-new-real-form'), 'POST', '/addresses');
        });
      }
      // Edit address buttons
      document.querySelectorAll('.bpet-addr-save-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var p = btn.closest('.bpet-addr-edit-panel');
          if (p && p.getAttribute('data-addr-id')) _saveAddr(btn, p, 'PUT', '/addresses/'+p.getAttribute('data-addr-id'));
        });
      });
    })();

    try { initBillingToggle(); } catch (e) { console.error('[boopr] initBillingToggle error:', e); }
    try { initDeleteAccount(); } catch (e) { console.error('[boopr] initDeleteAccount error:', e); }
    try { initClubTab(); } catch (e) { console.error('[boopr] initClubTab error:', e); }
    try { initServicesTab(); } catch (e) { console.error('[boopr] initServicesTab error:', e); }

    // Load pets + owner profile (always force refresh on page load to prevent stale data)
    clearAllCaches();
    Promise.all([fetchPets(true), fetchOwnerProfile(true)]).then(function (results) {
      allPets = results[0] || [];
      ownerProfile = results[1];

      // Init billing form with owner data
      try { initBillingForm(ownerProfile); } catch (e) { console.error('[boopr] initBillingForm error:', e); }

      if (allPets.length === 0) {
        var skipped = sessionStorage.getItem('bpet_wizard_skipped');
        if (skipped) {
          var emptyEl = document.getElementById('bpet-home-empty');
          if (emptyEl) emptyEl.style.display = 'block';
          var ctaBtn = document.getElementById('bpet-empty-cta');
          if (ctaBtn) {
            ctaBtn.addEventListener('click', function () {
              emptyEl.style.display = 'none';
              sessionStorage.removeItem('bpet_wizard_skipped');
              showWizard();
            });
          }
        } else {
          showWizard();
        }
        hideLoading();
        return;
      }

      renderHeader();
      renderDashboard(getActivePet());
      hideLoading();
    }).catch(function (err) {
      console.error('[boopr] Dashboard load error:', err);
      hideLoading();
      // Show error message to user
      var loadEl = document.getElementById('bpet-home-loading');
      if (loadEl) {
        loadEl.style.display = 'block';
        loadEl.textContent = 'Eroare la încărcare. Reîncarcă pagina.';
      }
    });
  }

  function hideLoading() {
    var el = document.getElementById('bpet-home-loading');
    if (el) el.style.display = 'none';
    var el2 = document.getElementById('bpet-pet-loading');
    if (el2) el2.style.display = 'none';
  }

  // ── Header: render owner + pet cards ────────────────────────────────
  function renderHeader() {
    var petsRow = document.getElementById('bpet-pets-row');
    var addBtn = document.getElementById('bpet-add-pet-btn');
    if (!petsRow) return;

    // Show add pet button
    if (addBtn) {
      addBtn.style.display = '';
      addBtn.onclick = function () { showWizard(true); };
    }

    // Render pet cards
    var html = '';
    allPets.forEach(function (pet, idx) {
      var isActive = idx === activePetIndex;
      var metaParts = [];
      if (pet.breed) metaParts.push(pet.breed);
      if (pet.weight) metaParts.push(pet.weight + 'kg');
      html += '<div class="bpet-pet-card' + (isActive ? ' active' : '') + '" data-pet-idx="' + idx + '">' +
        '<div class="bpet-pet-card-avatar">' + petAvatarHtml(pet, 40) + '</div>' +
        '<div class="bpet-pet-card-info">' +
          '<div class="bpet-pet-card-name">' + pet.name + '</div>' +
          '<div class="bpet-pet-card-meta">' + metaParts.join(' · ') + '</div>' +
        '</div>' +
      '</div>';
    });
    petsRow.innerHTML = html;

    // Pet card click handlers → switch active pet + navigate to pet tab
    petsRow.querySelectorAll('.bpet-pet-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var idx = parseInt(card.getAttribute('data-pet-idx'));
        if (idx !== activePetIndex) {
          activePetIndex = idx;
          renderHeader();
          renderDashboard(getActivePet());
          // If on health tab, reload health data for new pet
          var healthPanel = document.getElementById('bpet-tab-health');
          if (healthPanel && healthPanel.classList.contains('active')) {
            initHealthTab(getActivePet());
          }
        }
      });
    });

    // Owner avatar + name → navigate to Profile tab
    var ownerAvatar = document.getElementById('bpet-owner-avatar');
    if (ownerAvatar) {
      ownerAvatar.style.cursor = 'pointer';
      ownerAvatar.title = 'Editează profilul';
      ownerAvatar.onclick = function () { switchTab('profile'); };
    }
    var headerName = document.getElementById('bpet-header-name');
    if (headerName) {
      headerName.style.cursor = 'pointer';
      headerName.title = 'Editează profilul';
      headerName.onclick = function () { switchTab('profile'); };
    }

    // Dynamic tab label
    var petLabel = document.getElementById('bpet-nav-pet-label');
    if (petLabel) {
      petLabel.textContent = allPets.length > 1 ? 'Câinii mei' : 'Câinele meu';
    }
  }

  function ensureHomeStructure() {
    // No DOM manipulation — new liquid has correct order already
  }

  function renderDashboard(profile) {
    if (!profile) return;

    ensureHomeStructure();

    // Home tab — DARF product selector + Portion
    var darfSelector = document.getElementById('bpet-darf-selector');
    var darfSelect = document.getElementById('bpet-darf-product');
    var darfPetName = document.getElementById('bpet-darf-pet-name');
    var portionDiv = document.getElementById('bpet-home-portion');

    if (darfSelector && darfSelect && profile.weight && profile.activity_level) {
      var petIsPuppy = isPuppy(profile);
      var petIsOverweight = isOverweight(profile);

      // Populate DARF dropdown with smart filtering
      darfSelect.innerHTML = '<option value="">— Alege produsul DARF —</option>';
      var savedProduct = getSavedDarfProduct(profile.id);
      // Saved product no longer in the catalog list: forget it
      if (savedProduct && !DARF_PRODUCTS.some(function (p) { return p.name === savedProduct; })) {
        savedProduct = '';
        saveDarfProduct(profile.id, '');
      }
      var recommendedProduct = '';

      if (petIsPuppy) {
        recommendedProduct = 'DARF Puppy';
      } else if (petIsOverweight) {
        recommendedProduct = 'DARF Light';
      }

      // Choice made before it was stored on the account: move it to the account once
      var petForFood = findPetById(profile.id);
      if (petForFood && !petForFood.current_food && savedProduct && savedProduct !== recommendedProduct) {
        saveDarfProduct(profile.id, savedProduct, true);
      }

      // Auto-set recommended product if nothing saved
      if (recommendedProduct && !savedProduct) {
        savedProduct = recommendedProduct;
        saveDarfProduct(profile.id, recommendedProduct);
      }

      DARF_PRODUCTS.forEach(function (prod) {
        var opt = document.createElement('option');
        opt.value = prod.name;
        var label = prod.name + ' (' + prod.kcal + ' kcal/100g)';
        if (prod.name === recommendedProduct) label += ' ★ Recomandat';
        opt.textContent = label;
        if (prod.name === savedProduct) opt.selected = true;
        darfSelect.appendChild(opt);
      });

      // Update pet name in label
      if (darfPetName) darfPetName.textContent = profile.name;
      darfSelector.style.display = 'block';

      // Show recommendation banner
      var recBanner = document.getElementById('bpet-darf-recommendation');
      if (!recBanner) {
        recBanner = document.createElement('div');
        recBanner.id = 'bpet-darf-recommendation';
        darfSelector.appendChild(recBanner);
      }

      var isFemDash = profile.sex === 'F' || profile.sex === 'femela' || profile.sex === 'female';
      var puiutDash = isFemDash ? 'puiuță' : 'puiuț';
      var alOroDash = isFemDash ? 'a o' : 'a-l';
      if (petIsPuppy) {
        var ageMonths = petAgeMonths(profile.date_of_birth);
        recBanner.style.cssText = 'margin-top:10px;padding:10px 14px;border-radius:8px;font-size:13px;background:#fff8e1;border:1px solid #ffe082;color:#6d4c00;';
        recBanner.innerHTML = '🐾 <strong>' + profile.name + '</strong> are ' + (ageMonths || '') + ' luni — este încă ' + puiutDash + '! ' +
          'Pentru o creștere sănătoasă, îi recomandăm <strong>DARF Puppy</strong> care are un aport caloric mai mare (' +
          getDarfKcal('DARF Puppy') + ' kcal/100g) special formulat pentru pui.';
      } else if (petIsOverweight) {
        recBanner.style.cssText = 'margin-top:10px;padding:10px 14px;border-radius:8px;font-size:13px;background:#e3f2fd;border:1px solid #90caf9;color:#0d47a1;';
        recBanner.innerHTML = '⚖️ <strong>' + profile.name + '</strong> are nevoie de un regim echilibrat. ' +
          'Îi recomandăm <strong>DARF Light</strong> (' + getDarfKcal('DARF Light') + ' kcal/100g) ' +
          'sau <strong>DARF Cal</strong> (' + getDarfKcal('DARF Cal') + ' kcal/100g) — ' +
          'formulate cu mai puține calorii pentru ' + alOroDash + ' ajuta să revină la greutatea ideală.';
      } else {
        recBanner.style.cssText = 'display:none';
        recBanner.innerHTML = '';
      }

      // Render portion with saved or default kcal
      function renderPortion() {
        var selectedProduct = darfSelect.value;
        var kcal = selectedProduct ? getDarfKcal(selectedProduct) : 394;
        var p = calcPortion(profile.weight, profile.activity_level, profile.meals_per_day, kcal);
        if (p && portionDiv) {
          var productLabel = selectedProduct || 'DARF';
          portionDiv.innerHTML =
            '<div class="bpet-portion">' +
              '<div class="bpet-portion-title">Porția zilnică ' + productLabel + ' pentru ' + profile.name + '</div>' +
              '<div class="bpet-portion-val">' + p.total + '<small> g/zi</small></div>' +
              '<div class="bpet-portion-sub">' + p.perMeal + 'g × ' + p.meals + ' mese • ' + p.kcal + ' kcal/zi • ' + p.kcalPer100g + ' kcal/100g</div>' +
            '</div>';
          portionDiv.style.display = 'block';
        }
      }

      renderPortion();

      // Change handler — recalculate + persist
      darfSelect.onchange = function () {
        var chosen = darfSelect.value;
        profile.current_food = chosen || null;
        saveDarfProduct(profile.id, chosen, true).then(function (ok) {
          showDarfSaveError(darfSelect, !ok);
        });
        renderPortion();
        renderHomeStats(profile);
      };
    } else if (darfSelector) {
      darfSelector.style.display = 'none';
    }
    if (portionDiv && (!profile.weight || !profile.activity_level)) {
      portionDiv.style.display = 'none';
    }

    // Home tab — Stats + weight + DARF recs
    // renderHomeHealth e apelat din initHealthTab după ce conditions se încarcă async
    renderHomeStats(profile);
    renderHomeWeight(profile);
    renderHomeRecommendations(profile);

    // Pet tab — Edit form
    renderPetEditForm(profile);

    // Health tab — Weight tracking + diagnostics
    initHealthTab(profile);

    // Sync billing to cart
    syncBillingToCart(ownerProfile);
  }

  function renderPetEditForm(profile) {
    var content = document.getElementById('bpet-pet-content');
    if (!content) return;

    var sexM = profile.sex === 'male' ? ' checked' : '';
    var sexF = profile.sex === 'female' ? ' checked' : '';

    var activityOptions = [
      { v: '', l: 'Alege nivelul...' },
      { v: '1.0', l: 'Inactiv / Sedentar' },
      { v: '1.2', l: 'Supraponderal' },
      { v: '1.4', l: 'Sterilizat, puțin activ' },
      { v: '1.6', l: 'Sterilizat, activ normal' },
      { v: '1.8', l: 'Nesterilizat, adult activ' },
      { v: '2.5', l: 'Foarte activ / Câine de lucru' },
      { v: '2.0', l: 'Pui 4-12 luni' },
      { v: '3.0', l: 'Pui sub 4 luni / Gestație' },
    ];
    var actOpts = activityOptions.map(function (o) {
      var sel = o.v !== '' && parseFloat(profile.activity_level) === parseFloat(o.v) ? ' selected' : '';
      return '<option value="' + o.v + '"' + sel + '>' + o.l + '</option>';
    }).join('');

    var mealsOpts = [1, 2, 3, 4].map(function (n) {
      var sel = (profile.meals_per_day || 2) === n ? ' selected' : '';
      return '<option value="' + n + '"' + sel + '>' + n + (n === 1 ? ' masă' : ' mese') + '</option>';
    }).join('');

    var avatarContent = petAvatarHtml(profile, 72);

    // Show delete button only if 2+ pets
    var deleteHtml = allPets.length > 1
      ? '<button type="button" class="bpet-delete-pet" id="bpet-delete-pet">Șterge câinele</button>'
      : '';

    content.innerHTML =
      '<div class="bpet-card">' +
        '<div class="bpet-card-title">Profil ' + profile.name + '</div>' +
        '<div style="display:flex;align-items:center;gap:16px;margin-bottom:16px">' +
          '<div class="bpet-avatar" id="bpet-pet-avatar" title="Schimbă poza" style="cursor:pointer;position:relative;overflow:hidden;width:72px;height:72px;border-radius:50%;">' +
            avatarContent +
            '<span class="bpet-avatar-cam">+</span>' +
          '</div>' +
          '<div style="font-size:13px;opacity:0.5">Click pe avatar pentru a schimba poza</div>' +
        '</div>' +
        '<div class="bpet-form-row">' +
          '<label class="bpet-form-label">Nume</label>' +
          '<input type="text" class="bpet-form-input" id="bpet-edit-name" value="' + (profile.name || '') + '">' +
        '</div>' +
        '<div class="bpet-form-row">' +
          '<label class="bpet-form-label">Rasă</label>' +
          '<div class="bpet-breed-combo" id="bpet-edit-breed-combo">' +
            '<input type="text" class="bpet-form-input" id="bpet-edit-breed" value="' + (profile.breed || '') + '" autocomplete="off">' +
            '<div class="bpet-breed-dropdown" id="bpet-edit-breed-dropdown"></div>' +
          '</div>' +
        '</div>' +
        '<div class="bpet-form-row">' +
          '<label class="bpet-form-label">Sex</label>' +
          '<div class="bpet-form-half">' +
            '<label style="display:flex;align-items:center;gap:6px;cursor:pointer"><input type="radio" name="bpet-edit-sex" value="male"' + sexM + '> Mascul</label>' +
            '<label style="display:flex;align-items:center;gap:6px;cursor:pointer"><input type="radio" name="bpet-edit-sex" value="female"' + sexF + '> Femelă</label>' +
          '</div>' +
        '</div>' +
        '<div class="bpet-form-half">' +
          '<div class="bpet-form-row">' +
            '<label class="bpet-form-label">Data nașterii</label>' +
            '<input type="date" class="bpet-form-input" id="bpet-edit-dob" value="' + (profile.date_of_birth || '') + '">' +
          '</div>' +
          '<div class="bpet-form-row">' +
            '<label class="bpet-form-label">Greutate ideală (kg)</label>' +
            '<input type="number" class="bpet-form-input" id="bpet-edit-weight" value="' + (profile.weight || '') + '" min="0.5" max="120" step="0.5">' +
          '</div>' +
        '</div>' +
        '<div class="bpet-form-half">' +
          '<div class="bpet-form-row">' +
            '<label class="bpet-form-label">Nivel activitate</label>' +
            '<select class="bpet-form-select" id="bpet-edit-activity">' + actOpts + '</select>' +
          '</div>' +
          '<div class="bpet-form-row">' +
            '<label class="bpet-form-label">Mese pe zi</label>' +
            '<select class="bpet-form-select" id="bpet-edit-meals">' + mealsOpts + '</select>' +
          '</div>' +
        '</div>' +
        '<button class="bpet-btn" id="bpet-edit-save" style="margin-top:8px">Salvează modificările</button>' +
        '<span id="bpet-edit-status" style="margin-left:12px;font-size:13px;opacity:0.6"></span>' +
        deleteHtml +
      '</div>' +

      // Allergies section
      '<div class="bpet-card" style="margin-top:16px">' +
        '<div class="bpet-card-title">Alergii / Sensibilități</div>' +
        '<input type="text" class="bpet-form-input" id="bpet-edit-allergy-search" placeholder="Caută ingredient..." style="margin-bottom:8px">' +
        '<div class="bpet-ing-list" id="bpet-edit-allergy-list"></div>' +
        '<div class="bpet-ing-selected" id="bpet-edit-allergy-selected"></div>' +
        '<button class="bpet-btn" id="bpet-edit-allergy-save" style="margin-top:12px">Salvează Modificările</button>' +
        '<span id="bpet-edit-allergy-status" style="margin-left:12px;font-size:13px;opacity:0.6"></span>' +
      '</div>';

    content.style.display = 'block';

    // Force photo fill on form avatar — overrides any theme CSS
    if (profile.photo_url) {
      var avatarDiv = document.getElementById('bpet-pet-avatar');
      console.log('[boopr] avatarDiv found:', !!avatarDiv, '| photo_url:', profile.photo_url);
      if (avatarDiv) {
        var photoImg = avatarDiv.querySelector('img:not(.breed-icon)');
        console.log('[boopr] photoImg found:', !!photoImg, photoImg ? photoImg.outerHTML.substring(0, 100) : '');
        if (photoImg) {
          photoImg.style.setProperty('position', 'absolute', 'important');
          photoImg.style.setProperty('top', '0', 'important');
          photoImg.style.setProperty('left', '0', 'important');
          photoImg.style.setProperty('width', '72px', 'important');
          photoImg.style.setProperty('height', '72px', 'important');
          photoImg.style.setProperty('min-width', '72px', 'important');
          photoImg.style.setProperty('min-height', '72px', 'important');
          photoImg.style.setProperty('max-width', 'none', 'important');
          photoImg.style.setProperty('max-height', 'none', 'important');
          photoImg.style.setProperty('object-fit', 'cover', 'important');
          photoImg.style.setProperty('display', 'block', 'important');
          photoImg.style.setProperty('border-radius', '0', 'important');
          photoImg.style.setProperty('transform', 'none', 'important');
          console.log('[boopr] styles applied. Final style:', photoImg.getAttribute('style'));
        }
        // Also set background as fallback
        avatarDiv.style.setProperty('background-image', 'url(' + profile.photo_url + ')', 'important');
        avatarDiv.style.setProperty('background-size', 'cover', 'important');
        avatarDiv.style.setProperty('background-position', 'center', 'important');
        console.log('[boopr] bg applied to container. Container style:', avatarDiv.getAttribute('style'));
      }
    }

    // Init breed combobox
    initBreedCombobox('bpet-edit-breed', 'bpet-edit-breed-dropdown');

    // Save profile handler
    document.getElementById('bpet-edit-save').addEventListener('click', function () {
      var btn = this;
      btn.disabled = true;
      var sexEl = document.querySelector('input[name="bpet-edit-sex"]:checked');
      var body = {
        name: document.getElementById('bpet-edit-name').value.trim(),
        breed: document.getElementById('bpet-edit-breed').value.trim(),
        sex: sexEl ? sexEl.value : null,
        date_of_birth: document.getElementById('bpet-edit-dob').value || null,
        weight: parseFloat(document.getElementById('bpet-edit-weight').value) || null,
        activity_level: parseFloat(document.getElementById('bpet-edit-activity').value) || null,
        meals_per_day: parseInt(document.getElementById('bpet-edit-meals').value) || 2,
      };
      api('/pets/' + profile.id, { method: 'POST', body: body }).then(function (data) {
        btn.disabled = false;
        var status = document.getElementById('bpet-edit-status');
        if (data.ok) {
          status.textContent = 'Salvat!';
          status.style.color = '#4caf50';
          clearAllCaches();
          fetchPets(true).then(function (pets) {
            allPets = pets;
            renderHeader();
            renderDashboard(getActivePet());
          });
        } else {
          status.textContent = 'Eroare: ' + (data.error || 'necunoscută');
          status.style.color = '#c00';
        }
        setTimeout(function () { status.textContent = ''; }, 3000);
      });
    });

    // Delete pet handler
    var deleteBtn = document.getElementById('bpet-delete-pet');
    if (deleteBtn) {
      deleteBtn.addEventListener('click', function () {
        if (!confirm('Sigur vrei să ștergi profilul lui ' + profile.name + '?')) return;
        deleteBtn.disabled = true;
        api('/pets/' + profile.id, { method: 'DELETE' }).then(function (data) {
          if (data.ok) {
            clearAllCaches();
            activePetIndex = 0;
            fetchPets(true).then(function (pets) {
              allPets = pets;
              renderHeader();
              renderDashboard(getActivePet());
            });
          } else {
            deleteBtn.disabled = false;
            alert('Eroare: ' + (data.error || 'necunoscută'));
          }
        });
      });
    }

    // Load & render allergies
    loadAllergiesEditor(profile);

    // Photo upload handler
    initAvatarUpload('bpet-pet-avatar', profile);
  }

  function initAvatarUpload(avatarId, profile) {
    var avatarEl = document.getElementById(avatarId);
    var fileInput = document.getElementById('bpet-avatar-input');
    if (!avatarEl || !fileInput) return;

    avatarEl.addEventListener('click', function () {
      // Store the pet ID for the upload handler
      fileInput._bpetPetId = profile.id;
      fileInput.click();
    });

    if (!fileInput._bpetBound) {
      fileInput._bpetBound = true;
      fileInput.addEventListener('change', function () {
        var file = fileInput.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) { alert('Selectează o imagine.'); return; }
        if (file.size > 2 * 1024 * 1024) { alert('Imaginea trebuie să fie sub 2MB.'); return; }

        var formData = new FormData();
        formData.append('photo', file);

        var petId = fileInput._bpetPetId;
        var uploadPath = petId ? '/pets/' + petId + '/photo' : '/pet-profile/photo';

        apiUpload(uploadPath, formData).then(function (data) {
          if (data.ok && data.photo_url) {
            clearAllCaches();
            fetchPets(true).then(function (pets) {
              allPets = pets;
              renderHeader();
              renderDashboard(getActivePet());
            });
          } else {
            alert('Eroare la upload: ' + (data.error || 'necunoscută'));
          }
        }).catch(function () { alert('Eroare la upload.'); });

        fileInput.value = '';
      });
    }
  }

  // ── Allergies editor ───────────────────────────────────────────────────
  var currentAllergyIds = [];

  function loadAllergiesEditor(profile) {
    currentAllergyIds = (profile.allergies || []).map(function (a) { return a.id; });

    api('/ingredients').then(function (data) {
      if (!data.ok) return;
      var ingredients = data.ingredients || [];

      renderAllergyList('bpet-edit-allergy-list', 'bpet-edit-allergy-selected', 'bpet-edit-allergy-search', ingredients, currentAllergyIds, function (ids) {
        currentAllergyIds = ids;
      });
    });

    var saveBtn = document.getElementById('bpet-edit-allergy-save');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        saveBtn.disabled = true;
        api('/pets/' + profile.id + '/allergies', { method: 'POST', body: { ingredient_ids: currentAllergyIds } }).then(function (data) {
          saveBtn.disabled = false;
          var status = document.getElementById('bpet-edit-allergy-status');
          if (data.ok) {
            status.textContent = 'Salvat!'; status.style.color = '#4caf50';
            clearAllCaches();
          } else {
            status.textContent = 'Eroare'; status.style.color = '#c00';
          }
          setTimeout(function () { status.textContent = ''; }, 3000);
        });
      });
    }
  }

  function renderAllergyList(listId, selectedId, searchId, ingredients, selectedIds, onChange) {
    var listEl = document.getElementById(listId);
    var selectedEl = document.getElementById(selectedId);
    var searchEl = document.getElementById(searchId);
    if (!listEl) return;

    // Normalize all IDs to strings to avoid type mismatch (DB returns int, getAttribute returns string)
    var selected = new Set(selectedIds.map(String));

    function render(filter) {
      var filtered = ingredients;
      if (filter) {
        var f = filter.toLowerCase();
        filtered = ingredients.filter(function (i) { return i.name.toLowerCase().indexOf(f) !== -1; });
      }
      var catOrder = { proteina: 0, cereale: 1, legume: 2, fructe: 3, uleiuri: 4, suplimente: 5 };
      var catLabels = { proteina: 'proteină', cereale: 'cereale', legume: 'legume', fructe: 'fructe', uleiuri: 'uleiuri / grăsimi', suplimente: 'suplimente / altele' };
      filtered.sort(function (a, b) {
        var ca = catOrder[a.category] != null ? catOrder[a.category] : 9;
        var cb = catOrder[b.category] != null ? catOrder[b.category] : 9;
        if (ca !== cb) return ca - cb;
        return a.name.localeCompare(b.name);
      });

      var html = '';
      var lastCat = '';
      filtered.forEach(function (i) {
        if (i.category !== lastCat) {
          lastCat = i.category;
          var label = catLabels[i.category] || i.category || '';
          if (label) html += '<div class="bpet-ing-cat-header">' + label.charAt(0).toUpperCase() + label.slice(1) + '</div>';
        }
        var checked = selected.has(String(i.id)) ? ' checked' : '';
        html += '<label class="bpet-ing-item"><input type="checkbox" value="' + i.id + '"' + checked + '> ' + i.name + '</label>';
      });
      listEl.innerHTML = html;

      if (selectedEl) {
        var selIngs = ingredients.filter(function (i) { return selected.has(String(i.id)); });
        selectedEl.innerHTML = selIngs.map(function (i) {
          return '<span class="bpet-ing-tag" data-id="' + i.id + '">' + i.name + ' ×</span>';
        }).join('');
      }
    }

    render('');

    listEl.addEventListener('change', function (e) {
      if (e.target.type !== 'checkbox') return;
      var id = e.target.value;
      if (e.target.checked) { selected.add(id); } else { selected.delete(id); }
      onChange(Array.from(selected));
      render(searchEl ? searchEl.value : '');
    });

    if (selectedEl) {
      selectedEl.addEventListener('click', function (e) {
        var tag = e.target.closest('.bpet-ing-tag');
        if (!tag) return;
        var id = tag.getAttribute('data-id');
        selected.delete(id);
        onChange(Array.from(selected));
        render(searchEl ? searchEl.value : '');
      });
    }

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        render(searchEl.value);
      });
    }
  }


  // ── Cart attribute sync (CUI + billing from owner profile) ─────────
  function syncBillingToCart(profile) {
    if (!profile) return;
    var attrs = {};
    if (profile.cui) attrs['CUI'] = profile.cui;
    if (profile.billing_company) attrs['Firma'] = profile.billing_company;
    if (profile.billing_address1 || profile.billing_city) {
      var parts = [profile.billing_address1, profile.billing_city, profile.billing_county, profile.billing_zip].filter(Boolean);
      attrs['Adresa facturare'] = parts.join(', ');
    }
    if (Object.keys(attrs).length === 0) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  // ── Address form handlers ──────────────────────────────────────────
  function initAddressForms() {
    var addBtn = document.getElementById('bpet-addr-add-btn');
    var newForm = document.getElementById('bpet-addr-new-form');
    if (addBtn && newForm) {
      addBtn.addEventListener('click', function () {
        newForm.classList.toggle('active');
        if (newForm.classList.contains('active')) {
          addBtn.style.display = 'none';
          var firstInput = newForm.querySelector('input[type="text"]');
          if (firstInput) firstInput.focus();
        }
      });
      var newCancel = document.getElementById('bpet-addr-new-cancel');
      if (newCancel) {
        newCancel.addEventListener('click', function () {
          newForm.classList.remove('active');
          addBtn.style.display = '';
        });
      }
    }

    document.querySelectorAll('.bpet-addr-edit-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addrId = btn.getAttribute('data-addr-id');
        var form = document.getElementById('bpet-addr-edit-' + addrId);
        if (form) {
          form.classList.toggle('active');
          if (form.classList.contains('active')) {
            var firstInput = form.querySelector('input[type="text"]');
            if (firstInput) firstInput.focus();
          }
        }
      });
    });

    document.querySelectorAll('.bpet-addr-cancel').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addrId = btn.getAttribute('data-addr-id');
        var form = document.getElementById('bpet-addr-edit-' + addrId);
        if (form) form.classList.remove('active');
      });
    });

    // Delete address via API
    document.querySelectorAll('.bpet-addr-delete').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addrId = btn.getAttribute('data-addr-id');
        if (!addrId || !confirm('Sigur vrei să ștergi această adresă?')) return;
        btn.disabled = true; btn.textContent = 'Se șterge...';
        api('/addresses/' + addrId, { method: 'DELETE' }).then(function (resp) {
          if (resp.ok) { window.location.href = '/account?tab=addresses'; }
          else { alert('Eroare la ștergere: ' + JSON.stringify(resp)); btn.disabled = false; btn.textContent = 'Șterge'; }
        }).catch(function (e) { alert('Eroare conexiune: ' + e.message); btn.disabled = false; btn.textContent = 'Șterge'; });
      });
    });

    // Address CRUD via Boopr API
    function getAddrData(container) {
      return {
        first_name: (container.querySelector('[name="address[first_name]"]') || {}).value || '',
        last_name: (container.querySelector('[name="address[last_name]"]') || {}).value || '',
        address1: (container.querySelector('[name="address[address1]"]') || {}).value || '',
        address2: (container.querySelector('[name="address[address2]"]') || {}).value || '',
        city: (container.querySelector('[name="address[city]"]') || {}).value || '',
        province: (container.querySelector('[name="address[province]"]') || {}).value || '',
        zip: (container.querySelector('[name="address[zip]"]') || {}).value || '',
        phone: (container.querySelector('[name="address[phone]"]') || {}).value || '',
        country: (container.querySelector('[name="address[country]"]') || {}).value || 'Romania',
      };
    }

    function saveAddr(btn, container, method, apiPath) {
      var data = getAddrData(container);
      if (!data.address1 || !data.city) { alert('Completează cel puțin adresa și orașul.'); return; }
      var origText = btn.textContent;
      btn.disabled = true; btn.textContent = 'Se salvează...';
      var auth = window.__booprAuth || {};
      fetch('https://api.boopr.ro/accounts' + apiPath, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'x-customer-id': String(auth.customer_id || ''),
          'x-customer-email': auth.customer_email || '',
          'x-customer-token': auth.token || '',
        },
        body: JSON.stringify(data),
      }).then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.ok) {
            sessionStorage.setItem('bpet_goto_tab', 'addresses');
            window.location.reload();
          } else {
            alert('Eroare: ' + (resp.error || 'necunoscută'));
            btn.disabled = false; btn.textContent = origText;
          }
        }).catch(function (e) {
          alert('Eroare de conexiune: ' + e.message);
          btn.disabled = false; btn.textContent = origText;
        });
    }

    // New address — click handler
    var newSaveBtn = document.getElementById('bpet-addr-new-save');
    if (newSaveBtn) {
      newSaveBtn.addEventListener('click', function () {
        var container = document.getElementById('bpet-addr-new-real-form');
        saveAddr(newSaveBtn, container, 'POST', '/addresses');
      });
    }

    // Edit address — click handlers (delegated)
    document.querySelectorAll('.bpet-addr-save-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.bpet-addr-edit-panel');
        var addrId = panel ? panel.getAttribute('data-addr-id') : null;
        if (!addrId) return;
        saveAddr(btn, panel, 'PUT', '/addresses/' + addrId);
      });
    });

  }

  // ── Profile inline edit toggle ─────────────────────────────────────
  function initProfileEdit() {
    // Use event delegation on document to ensure it works even if elements load late
    document.addEventListener('click', function (e) {
      if (e.target.closest('#bpet-profile-edit-btn')) {
        var viewSection = document.getElementById('bpet-profile-view');
        var editSection = document.getElementById('bpet-profile-edit');
        if (viewSection && editSection) {
          viewSection.classList.add('hidden');
          editSection.classList.add('visible');
        }
      }
      if (e.target.closest('#bpet-profile-cancel-btn')) {
        var viewSection = document.getElementById('bpet-profile-view');
        var editSection = document.getElementById('bpet-profile-edit');
        if (viewSection && editSection) {
          viewSection.classList.remove('hidden');
          editSection.classList.remove('visible');
        }
      }
    });
  }

  // ── Sector dropdown helper ────────────────────────────────────────
  function isBucharest(val) {
    if (!val) return false;
    var v = val.toLowerCase().trim()
      .replace(/ă/g, 'a').replace(/â/g, 'a').replace(/î/g, 'i')
      .replace(/ș/g, 's').replace(/ş/g, 's')
      .replace(/ț/g, 't').replace(/ţ/g, 't');
    return v === 'bucuresti' || v === 'bucharest' || v.indexOf('bucuresti') === 0;
  }

  function parseSectorFromCity(cityVal) {
    if (!cityVal) return '';
    var match = cityVal.match(/Sector\s+(\d)/i);
    return match ? match[1] : '';
  }

  // ── Billing toggle (wired early, no data needed) ────────────────────
  function initBillingToggle() {
    var billingToggle = document.getElementById('bpet-billing-diff-toggle');
    var billingFields = document.getElementById('bpet-billing-fields');
    var cuiToggle = document.getElementById('bpet-cui-toggle');
    var cuiFields = document.getElementById('bpet-cui-fields');
    var cuiInput = document.getElementById('bpet-edit-cui');

    if (!billingToggle || !billingFields) return;

    // Toggle billing fields visibility
    billingToggle.addEventListener('change', function () {
      if (billingToggle.checked) {
        billingFields.classList.add('visible');
      } else {
        billingFields.classList.remove('visible');
      }
    });

    // CUI toggle
    if (cuiToggle && cuiFields) {
      cuiToggle.addEventListener('change', function () {
        if (cuiToggle.checked) {
          cuiFields.classList.add('visible');
          if (cuiInput) cuiInput.focus();
        } else {
          cuiFields.classList.remove('visible');
        }
      });
    }
  }

  // ── Billing form handler (populate + save) ─────────────────────────
  function initBillingForm(profile) {
    var billingToggle = document.getElementById('bpet-billing-diff-toggle');
    var billingFields = document.getElementById('bpet-billing-fields');
    var cuiToggle = document.getElementById('bpet-cui-toggle');
    var cuiFields = document.getElementById('bpet-cui-fields');
    var cuiInput = document.getElementById('bpet-edit-cui');
    var billingCompany = document.getElementById('bpet-billing-company');
    var billingAddress1 = document.getElementById('bpet-billing-address1');
    var billingCity = document.getElementById('bpet-billing-city');
    var billingCounty = document.getElementById('bpet-billing-county');
    var billingZip = document.getElementById('bpet-billing-zip');
    var billingCountry = document.getElementById('bpet-billing-country');
    var sectorRow = document.getElementById('bpet-sector-row');
    var sectorSelect = document.getElementById('bpet-billing-sector');
    var saveBtn = document.getElementById('bpet-cui-save');
    var feedback = document.getElementById('bpet-cui-feedback');

    if (!saveBtn || !billingToggle || !billingFields) return;

    // Determine if billing data exists → auto-check toggle
    var hasBillingData = profile && (profile.billing_address1 || profile.cui || profile.billing_company);

    if (hasBillingData) {
      billingToggle.checked = true;
      billingFields.classList.add('visible');
    }

    if (!profile) return;

    // Pre-fill billing address fields
    if (billingAddress1) billingAddress1.value = profile.billing_address1 || '';
    if (billingCounty) billingCounty.value = profile.billing_county || '';
    if (billingZip) billingZip.value = profile.billing_zip || '';
    if (billingCountry) billingCountry.value = profile.billing_country || 'România';

    // Pre-fill city + sector
    if (billingCity) {
      var savedCity = profile.billing_city || '';
      var sector = parseSectorFromCity(savedCity);
      if (sector) {
        billingCity.value = 'București';
        if (sectorSelect) sectorSelect.value = sector;
        if (sectorRow) sectorRow.classList.add('visible');
        if (billingCounty) billingCounty.value = 'București';
      } else {
        billingCity.value = savedCity;
      }
    }

    // Pre-fill CUI toggle
    if (cuiToggle && cuiFields && cuiInput) {
      if (profile.cui) {
        cuiToggle.checked = true;
        cuiFields.classList.add('visible');
        cuiInput.value = profile.cui;
      }
      if (billingCompany) billingCompany.value = profile.billing_company || '';
    }

    // Sector dropdown
    if (billingCity && sectorRow && sectorSelect) {
      function checkSector() {
        if (isBucharest(billingCity.value)) {
          sectorRow.classList.add('visible');
          if (billingCounty) billingCounty.value = 'București';
        } else {
          sectorRow.classList.remove('visible');
          sectorSelect.value = '';
        }
      }
      billingCity.addEventListener('input', checkSector);
      billingCity.addEventListener('change', checkSector);
    }

    // Save billing → customer-profile endpoint
    saveBtn.addEventListener('click', function () {
      saveBtn.disabled = true;

      // If toggle unchecked, clear billing data
      if (!billingToggle.checked) {
        var clearBody = {
          cui: null,
          billing_company: null,
          billing_address1: null,
          billing_city: null,
          billing_county: null,
          billing_zip: null,
        };
        var clearPromise = api('/customer-profile', { method: 'POST', body: clearBody }).then(function (data) {
          if (!data.ok) return api('/pet-profile', { method: 'POST', body: clearBody });
          return data;
        }).catch(function () {
          return api('/pet-profile', { method: 'POST', body: clearBody });
        });
        clearPromise.then(function (data) {
          saveBtn.disabled = false;
          if (data && data.ok && feedback) {
            feedback.textContent = 'Datele de facturare au fost șterse.';
            feedback.classList.add('show');
            setTimeout(function () { feedback.classList.remove('show'); }, 4000);
          }
          clearAllCaches();
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { CUI: '', Firma: '', 'Adresa facturare': '' } })
          });
        }).catch(function () { saveBtn.disabled = false; });
        return;
      }

      var cityVal = billingCity ? billingCity.value.trim() : '';
      if (isBucharest(cityVal) && sectorSelect && sectorSelect.value) {
        cityVal = 'București, Sector ' + sectorSelect.value;
      }

      var body = {
        billing_address1: billingAddress1 ? billingAddress1.value.trim() || null : null,
        billing_city: cityVal || null,
        billing_county: billingCounty ? billingCounty.value.trim() || null : null,
        billing_zip: billingZip ? billingZip.value.trim() || null : null,
        billing_country: billingCountry ? billingCountry.value.trim() || null : null,
      };

      if (cuiToggle && cuiToggle.checked) {
        body.cui = cuiInput ? cuiInput.value.trim() || null : null;
        body.billing_company = billingCompany ? billingCompany.value.trim() || null : null;
      } else {
        body.cui = null;
        body.billing_company = null;
      }

      var savePromise = api('/customer-profile', { method: 'POST', body: body }).then(function (data) {
        if (!data.ok) return api('/pet-profile', { method: 'POST', body: body });
        return data;
      }).catch(function () {
        return api('/pet-profile', { method: 'POST', body: body });
      });
      savePromise.then(function (data) {
        saveBtn.disabled = false;
        if (data && data.ok) {
          if (feedback) {
            feedback.textContent = 'Salvat! Datele de facturare vor apărea automat pe comenzile tale.';
            feedback.classList.add('show');
            setTimeout(function () { feedback.classList.remove('show'); }, 4000);
          }
          clearAllCaches();
          syncBillingToCart(Object.assign({}, profile || {}, body));
        }
      }).catch(function () {
        saveBtn.disabled = false;
      });
    });
  }


  // ══════════════════════════════════════════════════════════════════════
  // BREED COMBOBOX (replaces datalist)
  // ══════════════════════════════════════════════════════════════════════

  var breedsCache = null;

  function loadBreedsData() {
    if (breedsCache) return Promise.resolve(breedsCache);

    // Try localStorage cache (7 days)
    try {
      var cached = localStorage.getItem('boopr_breeds');
      if (cached) {
        var parsed = JSON.parse(cached);
        if (Date.now() - parsed._ts < 7 * 24 * 60 * 60 * 1000) {
          breedsCache = parsed.breeds;
          return Promise.resolve(breedsCache);
        }
      }
    } catch (e) { /* ignore */ }

    return api('/breeds').then(function (data) {
      if (data.ok && data.breeds) {
        breedsCache = data.breeds;
        try {
          localStorage.setItem('boopr_breeds', JSON.stringify({ breeds: data.breeds, _ts: Date.now() }));
        } catch (e) { /* ignore */ }
        return data.breeds;
      }
      return [];
    });
  }

  function initBreedCombobox(inputId, dropdownId) {
    var input = document.getElementById(inputId);
    var dropdown = document.getElementById(dropdownId);
    if (!input || !dropdown) return;

    var highlightIdx = -1;
    var filteredBreeds = [];

    loadBreedsData().then(function (breeds) {
      if (!breeds || !breeds.length) return;

      function renderDropdown(filter) {
        var f = (filter || '').toLowerCase();
        filteredBreeds = f
          ? breeds.filter(function (b) { return b.toLowerCase().indexOf(f) !== -1; })
          : breeds.slice(0, 50);

        if (filteredBreeds.length === 0) {
          dropdown.classList.remove('open');
          return;
        }

        highlightIdx = -1;
        dropdown.innerHTML = filteredBreeds.map(function (b, i) {
          return '<div class="bpet-breed-option" data-idx="' + i + '">' + b + '</div>';
        }).join('');
        dropdown.classList.add('open');
      }

      function selectBreed(val) {
        input.value = val;
        dropdown.classList.remove('open');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      input.addEventListener('focus', function () {
        renderDropdown(input.value);
      });

      input.addEventListener('input', function () {
        renderDropdown(input.value);
      });

      input.addEventListener('keydown', function (e) {
        if (!dropdown.classList.contains('open')) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          highlightIdx = Math.min(highlightIdx + 1, filteredBreeds.length - 1);
          updateHighlight();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          highlightIdx = Math.max(highlightIdx - 1, 0);
          updateHighlight();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (highlightIdx >= 0 && filteredBreeds[highlightIdx]) {
            selectBreed(filteredBreeds[highlightIdx]);
          }
        } else if (e.key === 'Escape') {
          dropdown.classList.remove('open');
        }
      });

      function updateHighlight() {
        dropdown.querySelectorAll('.bpet-breed-option').forEach(function (opt, i) {
          opt.classList.toggle('highlighted', i === highlightIdx);
          if (i === highlightIdx) opt.scrollIntoView({ block: 'nearest' });
        });
      }

      dropdown.addEventListener('click', function (e) {
        var opt = e.target.closest('.bpet-breed-option');
        if (opt) selectBreed(opt.textContent);
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (!input.contains(e.target) && !dropdown.contains(e.target)) {
          dropdown.classList.remove('open');
        }
      });
    });
  }


  // ══════════════════════════════════════════════════════════════════════
  // ONBOARDING WIZARD
  // ══════════════════════════════════════════════════════════════════════

  function showWizard(addPetMode) {
    var overlay = document.getElementById('bpet-wizard-overlay');
    if (!overlay) return;
    overlay.classList.add('active');

    // Update wizard title for add pet mode
    var wizTitle = overlay.querySelector('.bpet-wizard-title');
    var wizSub = overlay.querySelector('.bpet-wizard-sub');
    if (addPetMode) {
      if (wizTitle) wizTitle.textContent = 'Adaugă un câine nou';
      if (wizSub) wizSub.textContent = 'Completează datele pentru noul tău câine.';
    } else {
      if (wizTitle) wizTitle.textContent = 'Bine ai venit! 🐕';
      if (wizSub) wizSub.textContent = 'Spune-ne despre câinele tău pentru recomandări personalizate.';
    }

    // Clear wizard fields
    var wizName = document.getElementById('bpet-wiz-name');
    var wizBreed = document.getElementById('bpet-wiz-breed');
    var wizDob = document.getElementById('bpet-wiz-dob');
    var wizWeight = document.getElementById('bpet-wiz-weight');
    var wizActivity = document.getElementById('bpet-wiz-activity');
    var wizMeals = document.getElementById('bpet-wiz-meals');
    if (wizName) wizName.value = '';
    if (wizBreed) wizBreed.value = '';
    if (wizDob) wizDob.value = '';
    if (wizWeight) wizWeight.value = '';
    if (wizActivity) wizActivity.selectedIndex = 0;
    if (wizMeals) wizMeals.value = '2';
    document.querySelectorAll('input[name="bpet-wiz-sex"]').forEach(function (r) { r.checked = false; });

    // Wizard skip handler
    var skipLink = document.getElementById('bpet-wizard-skip');
    if (skipLink) {
      // Remove old handlers by cloning
      var newSkip = skipLink.cloneNode(true);
      skipLink.parentNode.replaceChild(newSkip, skipLink);
      newSkip.addEventListener('click', function () {
        overlay.classList.remove('active');
        if (!addPetMode) {
          sessionStorage.setItem('bpet_wizard_skipped', '1');
          var emptyEl = document.getElementById('bpet-home-empty');
          if (emptyEl) emptyEl.style.display = 'block';
          var ctaBtn = document.getElementById('bpet-empty-cta');
          if (ctaBtn) {
            ctaBtn.addEventListener('click', function () {
              emptyEl.style.display = 'none';
              sessionStorage.removeItem('bpet_wizard_skipped');
              showWizard();
            });
          }
        }
      });
    }

    var currentStep = 0;
    var wizAllergyIds = [];

    // Init breed combobox for wizard
    initBreedCombobox('bpet-wiz-breed', 'bpet-wiz-breed-dropdown');

    // Load ingredients for step 4
    api('/ingredients').then(function (data) {
      if (!data.ok) return;
      renderAllergyList('bpet-wiz-allergy-list', 'bpet-wiz-allergy-selected', 'bpet-wiz-allergy-search', data.ingredients || [], [], function (ids) {
        wizAllergyIds = ids;
      });
    });

    function goToStep(n) {
      currentStep = n;
      var steps = overlay.querySelectorAll('.bpet-wizard-step');
      steps.forEach(function (s, i) {
        s.classList.toggle('active', i === n);
      });
      var dots = overlay.querySelectorAll('.bpet-wizard-dot');
      dots.forEach(function (d, i) {
        d.classList.remove('active', 'done');
        if (i < n) d.classList.add('done');
        if (i === n) d.classList.add('active');
      });
    }

    // Go to step 0
    goToStep(0);

    // Back buttons — clone to remove old handlers
    overlay.querySelectorAll('[data-wiz-back]').forEach(function (btn) {
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.addEventListener('click', function () { goToStep(currentStep - 1); });
    });

    // Step navigation — clone buttons to remove old handlers
    function replaceBtn(id, handler) {
      var btn = document.getElementById(id);
      if (!btn) return;
      var newBtn = btn.cloneNode(true);
      newBtn.id = id;
      btn.parentNode.replaceChild(newBtn, btn);
      newBtn.addEventListener('click', handler);
    }

    replaceBtn('bpet-wiz-next-0', function () {
      var name = document.getElementById('bpet-wiz-name').value.trim();
      if (!name) { document.getElementById('bpet-wiz-name').focus(); return; }
      goToStep(1);
    });

    replaceBtn('bpet-wiz-next-1', function () {
      var weight = document.getElementById('bpet-wiz-weight').value;
      if (!weight) { document.getElementById('bpet-wiz-weight').focus(); return; }
      goToStep(2);
    });

    replaceBtn('bpet-wiz-next-2', function () {
      var activity = document.getElementById('bpet-wiz-activity').value;
      if (!activity) { document.getElementById('bpet-wiz-activity').focus(); return; }
      goToStep(3);
    });

    // Final save
    replaceBtn('bpet-wiz-save', function () {
      var btn = document.getElementById('bpet-wiz-save');
      btn.disabled = true;
      btn.textContent = 'Se salvează...';

      var sexEl = document.querySelector('input[name="bpet-wiz-sex"]:checked');
      var body = {
        name: document.getElementById('bpet-wiz-name').value.trim(),
        breed: document.getElementById('bpet-wiz-breed').value.trim() || null,
        sex: sexEl ? sexEl.value : null,
        date_of_birth: document.getElementById('bpet-wiz-dob').value || null,
        weight: parseFloat(document.getElementById('bpet-wiz-weight').value) || null,
        activity_level: parseFloat(document.getElementById('bpet-wiz-activity').value) || null,
        meals_per_day: parseInt(document.getElementById('bpet-wiz-meals').value) || 2,
        onboarding_completed: true,
      };

      // Use /pets for adding 2nd+ pet, /pet-profile for first pet (backward compat)
      var createPath = addPetMode ? '/pets' : '/pet-profile';
      var createPromise = api(createPath, { method: 'POST', body: body });

      // If /pets fails (API not deployed yet), fall back to /pet-profile
      if (addPetMode) {
        createPromise = createPromise.then(function (data) {
          if (data.error === 'not_found') {
            console.warn('[boopr] /pets not available, falling back to /pet-profile');
            return api('/pet-profile', { method: 'POST', body: body });
          }
          return data;
        });
      }

      createPromise.then(function (data) {
        if (!data.ok) {
          console.error('[boopr] wizard save error:', data.error || data);
          btn.disabled = false;
          btn.textContent = 'Salvează profilul';
          return;
        }

        var newPetId = data.id;

        // Save allergies — try new endpoint, fall back to old
        var allergyPromise;
        if (wizAllergyIds.length) {
          allergyPromise = api('/pets/' + newPetId + '/allergies', { method: 'POST', body: { ingredient_ids: wizAllergyIds } })
            .then(function (aData) {
              // Fall back to old endpoint if new one not available
              if (aData.error === 'not_found' || aData.error === 'pet_not_found') {
                return api('/pet-profile/allergies', { method: 'POST', body: { ingredient_ids: wizAllergyIds } });
              }
              return aData;
            });
        } else {
          allergyPromise = Promise.resolve({ ok: true });
        }

        return allergyPromise.then(function () {
          overlay.classList.remove('active');
          clearAllCaches();

          // Try to load via /pets, fall back to /pet-profile
          fetchPets(true).then(function (pets) {
            if (pets.length > 0) {
              allPets = pets;
              activePetIndex = allPets.length - 1;
              renderHeader();
              renderDashboard(getActivePet());
            } else {
              // Fallback: load via old endpoint
              fetchProfile(true).then(function (profile) {
                if (profile) {
                  allPets = [profile];
                  activePetIndex = 0;
                  renderHeader();
                  renderDashboard(profile);
                }
              });
            }
            hideLoading();
            var emptyEl = document.getElementById('bpet-home-empty');
            if (emptyEl) emptyEl.style.display = 'none';
            var addBtn = document.getElementById('bpet-add-pet-btn');
            if (addBtn) addBtn.style.display = '';
          });
        });
      }).catch(function (err) {
        console.error('[boopr] wizard save failed:', err);
        btn.disabled = false;
        btn.textContent = 'Salvează profilul';
      });
    });
  }


  // ══════════════════════════════════════════════════════════════════════
  // PRODUCT PAGE — Badges + Calculator auto-fill
  // ══════════════════════════════════════════════════════════════════════

  function getIngredientsFromPage() {
    var allTitles = document.querySelectorAll('.accordion__title, .tab-link');
    for (var i = 0; i < allTitles.length; i++) {
      var titleText = allTitles[i].textContent.trim().toLowerCase();
      if (titleText.indexOf('ingrediente') !== -1) {
        var triggerId = allTitles[i].getAttribute('aria-controls');
        if (triggerId) {
          var body = document.getElementById(triggerId);
          if (body) return body.textContent;
        }
        var tabIdx = allTitles[i].getAttribute('data-tab');
        if (tabIdx !== null) {
          var tabContent = document.querySelector('.tab-content-' + tabIdx);
          if (tabContent) return tabContent.textContent;
        }
        var nextEl = allTitles[i].nextElementSibling;
        while (nextEl) {
          if (nextEl.classList.contains('accordion__body') || nextEl.classList.contains('tab-content')) {
            return nextEl.textContent;
          }
          nextEl = nextEl.nextElementSibling;
        }
      }
    }

    var allElements = document.querySelectorAll('h2, h3, h4, strong, b, p');
    for (var j = 0; j < allElements.length; j++) {
      var elText = allElements[j].textContent.trim();
      if (/^ingrediente\s*:/i.test(elText) || elText.toLowerCase() === 'ingrediente') {
        var parent = allElements[j].parentElement;
        if (parent) return parent.textContent;
      }
    }

    return null;
  }

  function stripDiacritics(str) {
    return str
      .replace(/[ăâ]/g, 'a').replace(/[ĂÂ]/g, 'A')
      .replace(/[îï]/g, 'i').replace(/[ÎÏ]/g, 'I')
      .replace(/[șş]/g, 's').replace(/[ȘŞ]/g, 'S')
      .replace(/[țţ]/g, 't').replace(/[ȚŢ]/g, 'T');
  }

  function checkAllergiesClientSide(allergies, ingredientText) {
    if (!ingredientText || !allergies || !allergies.length) return { safe: true, conflicts: [] };

    var text = stripDiacritics(ingredientText.toLowerCase());
    var stopPatterns = [/anali[tz]/i, /protein[a]\s+brut/i, /gr[a]simi\s+brut/i, /energie/i, /kcal/i];
    for (var s = 0; s < stopPatterns.length; s++) {
      var m = text.search(stopPatterns[s]);
      if (m !== -1) { text = text.substring(0, m); break; }
    }

    var conflicts = [];
    for (var i = 0; i < allergies.length; i++) {
      var kw = allergies[i];
      if (!kw.patterns) continue;
      for (var p = 0; p < kw.patterns.length; p++) {
        var pat = stripDiacritics(kw.patterns[p].toLowerCase());
        var re = new RegExp('\\b' + pat.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b');
        if (re.test(text)) {
          conflicts.push({ id: kw.id, name: kw.name });
          break;
        }
      }
    }

    return { safe: conflicts.length === 0, conflicts: conflicts };
  }

  // ── WhatsApp — actualizați cu numărul real Boopr ──
  var BOOPR_WA_URL = 'https://wa.me/40750454194';

  // Suplimente supraponderali — nepotrivite (fără info grăsime)
  var OVERWEIGHT_UNSUITABLE = [
    'ulei omega 3-6-9',
    'paul paulina ulei de somon',
    'paul paulina faina de burta verde',
    'paul paulina ulei de armurariu',
    'paul paulina ulei de ficat de cod',
    'paul paulina faina de oase de miel',
    'lulu kitchen jelly superfood cu afine',
    'lulu kitchen jelly superfood cu ananas',
    'three dog night colagen hidrolizat',
    'lulu kitchen jelly superfood cu spanac',
    'arctic blue ulei de peste'
  ];
  // Suplimente supraponderali — potrivite (fără info grăsime)
  var OVERWEIGHT_SUITABLE = [
    'three dog night joint flex',
    'three dog night slippery elm',
    'vetmed pets probiotic',
    'three dog night marshmallow',
    'three dog night pudra de macese',
    'biofunghi reishi',
    'biofunghi coriolus',
    'biofunghi chaga',
    'biofunghi cordyceps'
  ];

  function petAgeWeeks(dob) {
    if (!dob) return null;
    var birth = new Date(dob);
    if (isNaN(birth.getTime())) return null;
    return Math.floor((Date.now() - birth.getTime()) / 604800000);
  }

  function getUsageGuideText() {
    var allTitles = document.querySelectorAll('.accordion__title, .tab-link');
    for (var i = 0; i < allTitles.length; i++) {
      var t = stripDiacritics(allTitles[i].textContent.trim().toLowerCase());
      if (t.indexOf('ghid') !== -1 || t.indexOf('administrare') !== -1 || t.indexOf('utilizare') !== -1) {
        var triggerId = allTitles[i].getAttribute('aria-controls');
        if (triggerId) { var body = document.getElementById(triggerId); if (body) return body.textContent; }
        var next = allTitles[i].nextElementSibling;
        while (next) {
          if (next.classList.contains('accordion__body') || next.classList.contains('tab-content')) return next.textContent;
          next = next.nextElementSibling;
        }
      }
    }
    return null;
  }

  function getFatFromPage() {
    var text = getIngredientsFromPage() || document.body.textContent || '';
    // Prinde: "Grăsimi brute: 22,1%", "Grăsimi - 3%", "Grăsime brută: 8%", "Grăsime: 8%"
    var m = /gr[aă]simi?[^%\n]{1,25}?(\d+(?:[.,]\d+)?)\s*%/i.exec(text);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }

  function isProductOkForOverweight(fatPercent, pageTitle) {
    if (fatPercent !== null) return fatPercent < 10;
    var norm = stripDiacritics(pageTitle.toLowerCase()).replace(/[^a-z0-9& ]/g, ' ').replace(/\s+/g, ' ');
    for (var i = 0; i < OVERWEIGHT_SUITABLE.length; i++) {
      var parts = OVERWEIGHT_SUITABLE[i].split(' ');
      var ok = true;
      for (var j = 0; j < parts.length; j++) { if (norm.indexOf(parts[j]) === -1) { ok = false; break; } }
      if (ok) return true;
    }
    return false;
  }

  function initProductPage() {
    var auth = getAuth();
    if (!auth) return;

    var productIdMeta = document.querySelector('meta[property="og:type"][content="product"]');
    if (!productIdMeta && !document.querySelector('.product-single')) return;

    // Sync billing from owner profile
    fetchOwnerProfile().then(function (op) {
      if (op) syncBillingToCart(op);
    });

    fetchPets().then(function (pets) {
      if (!pets || !pets.length) return;

      // Auto-fill calculator with first pet
      autoFillCalculator(pets[0]);

      var ingredientText = getIngredientsFromPage();
      if (!ingredientText) {
        var titleEl = document.querySelector('.product__title, .product-single__title, h1');
        if (titleEl) ingredientText = titleEl.textContent;
      }

      // Check allergies + segment warnings for each pet
      var results = pets.map(function (pet) {
        var r = { pet: pet, safe: true, conflicts: [], isPuppy: isPuppy(pet), isOverweight: isOverweight(pet) };
        if (pet.allergies && pet.allergies.length > 0 && ingredientText) {
          var allergyResult = checkAllergiesClientSide(pet.allergies, ingredientText);
          r.safe = allergyResult.safe;
          r.conflicts = allergyResult.conflicts;
        }
        return r;
      });

      showProductBadges(results, pets.length);
    });
  }

  function showProductBadges(results, totalPets) {
    var titleBlock = document.querySelector('.product__block__title');
    if (!titleBlock) {
      titleBlock = document.querySelector('.product__title') ||
                   document.querySelector('.product-single__title') ||
                   document.querySelector('h1.product_name');
    }
    if (!titleBlock) return;

    var pageTitle = (document.querySelector('.product__title, .product-single__title, h1') || {}).textContent || '';
    var pageTitleLower = pageTitle.toLowerCase();
    // Detectare strictă — toate cer "darf" în titlu pentru a evita fals-pozitive
    // (ex: "Cubes Cal", "piele de cap de cal" nu sunt DARF Cal)
    var isDarfPuppyPage = pageTitleLower.indexOf('darf') !== -1 && pageTitleLower.indexOf('puppy') !== -1;
    var isDarfLightPage = pageTitleLower.indexOf('darf') !== -1 && pageTitleLower.indexOf('light') !== -1;
    var isDarfCalPage   = pageTitleLower.indexOf('darf') !== -1 && pageTitleLower.indexOf(' cal') !== -1;

    // Ghid de utilizare — verificăm mențiunea de 12 săptămâni
    var ghidText = getUsageGuideText() || '';
    var ghidHas12Weeks = /12\s*sapt/.test(stripDiacritics(ghidText.toLowerCase()));

    // Grăsime % din analiza nutrițională
    var fatPercent = getFatFromPage();

    document.querySelectorAll('.bpet-product-badge').forEach(function (el) { el.remove(); });

    var container = document.createElement('div');
    container.className = 'bpet-product-badge';
    container.style.cssText = 'margin:16px 0;display:flex;flex-direction:column;gap:8px;';

    results.forEach(function (r) {
      var isFem = r.pet.sex === 'F' || r.pet.sex === 'femela' || r.pet.sex === 'female';
      var potrivit = isFem ? 'Potrivită' : 'Potrivit';
      var puiut    = isFem ? 'puiuță' : 'puiuț';
      var alOro    = isFem ? 'a o' : 'a-l';
      var luiEi    = isFem ? 'ei' : 'lui';

      // ── Alergie ──
      if (!r.safe) {
        var allergyBadge = document.createElement('div');
        var names = r.conflicts.map(function (c) { return c.name; }).join(', ');
        allergyBadge.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff3f3;color:#c62828;border:1px solid #ffcdd2;';
        allergyBadge.innerHTML = '⚠ <strong>' + r.pet.name + '</strong> are sensibilitate la: <strong>' + names + '</strong>';
        container.appendChild(allergyBadge);
      }

      // ── Puppy ──
      var puppyOk = false;
      var puppyBadgeDone = false;
      if (r.isPuppy) {
        var ageWeeks = petAgeWeeks(r.pet.date_of_birth);
        if (ghidHas12Weeks) {
          if (ageWeeks !== null && ageWeeks < 12) {
            // Prea mic pentru produsul cu mențiune 12 săptămâni
            puppyBadgeDone = true;
            var ageWText = ageWeeks + (ageWeeks === 1 ? ' săptămână' : ' săptămâni');
            var pb = document.createElement('div');
            pb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff3f3;color:#c62828;border:1px solid #ffcdd2;';
            pb.innerHTML = '🐾 <strong>' + r.pet.name + '</strong> are ' + ageWText +
              ' și este prea mic' + (isFem ? 'ă' : '') + ' pentru acest produs (recomandat de la 12 săptămâni). ' +
              'Trebuie să mai crească puțin! ' +
              '<a href="' + BOOPR_WA_URL + '" target="_blank" rel="noopener" style="color:inherit;font-weight:700;text-decoration:underline;">Consultați-ne pe WhatsApp →</a>';
            container.appendChild(pb);
          } else {
            // Peste 12 săptămâni — produsul îi este potrivit
            puppyOk = true;
            if (isDarfPuppyPage && r.safe) {
              puppyBadgeDone = true;
              var pfb = document.createElement('div');
              pfb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:600;line-height:1.5;background:#e8f5e9;color:#2e7d32;border:1px solid #c8e6c9;';
              pfb.innerHTML = '🌟 Perfect pentru ' + r.pet.name + '! Formulat special pentru puii în creștere.';
              container.appendChild(pfb);
            }
          }
        } else {
          // Ghidul nu menționează vârsta — consultați WhatsApp
          puppyBadgeDone = true;
          var ageM = petAgeMonths(r.pet.date_of_birth);
          var ageMText = ageM ? ' (' + ageM + ' luni)' : '';
          var cb = document.createElement('div');
          cb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff8e1;color:#6d4c00;border:1px solid #ffe082;';
          cb.innerHTML = '🐾 <strong>' + r.pet.name + '</strong>' + ageMText +
            ' este ' + puiut + '. Nu știm sigur dacă produsul este potrivit pentru vârsta ' + luiEi + '. ' +
            '<a href="' + BOOPR_WA_URL + '" target="_blank" rel="noopener" style="color:inherit;font-weight:700;text-decoration:underline;">Consultați-ne pe WhatsApp →</a>';
          container.appendChild(cb);
        }
      }

      // ── Supraponderal ──
      var overweightOk = false;
      var overweightBadgeDone = false;
      if (r.isOverweight) {
        var lightCalRec = '<strong>DARF Light</strong> (' + getDarfKcal('DARF Light') + ' kcal/100g) sau ' +
          '<strong>DARF Cal</strong> (' + getDarfKcal('DARF Cal') + ' kcal/100g)';

        if (isDarfLightPage || isDarfCalPage) {
          // DARF Light / DARF Cal — alegerea ideală
          overweightOk = true;
          overweightBadgeDone = true;
          var lb = document.createElement('div');
          lb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:600;line-height:1.5;background:#e8f5e9;color:#2e7d32;border:1px solid #c8e6c9;';
          lb.innerHTML = '🌟 Alegerea perfectă pentru ' + r.pet.name + '! Formulat special pentru managementul greutății.';
          container.appendChild(lb);

        } else if (fatPercent !== null && fatPercent >= 10) {
          // Grăsime ridicată — nepotrivit
          overweightBadgeDone = true;
          var wb = document.createElement('div');
          wb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff3f3;color:#c62828;border:1px solid #ffcdd2;';
          wb.innerHTML = '⚖️ <strong>' + r.pet.name + '</strong> are câteva kilograme în plus. ' +
            'Acest produs are <strong>' + fatPercent + '% grăsime</strong> — prea mult pentru un câine supraponderal. ' +
            'Ca hrană principală îi recomandăm ' + lightCalRec + '.';
          container.appendChild(wb);

        } else if (fatPercent !== null && fatPercent < 10) {
          // Grăsime scăzută — potrivit, dar rar
          overweightOk = true;
          overweightBadgeDone = true;
          var ab = document.createElement('div');
          ab.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff8e1;color:#6d4c00;border:1px solid #ffe082;';
          ab.innerHTML = '⚖️ <strong>' + r.pet.name + '</strong> are câteva kilograme în plus. ' +
            'Acest produs are <strong>' + fatPercent + '% grăsime</strong> — suficient de slab, dar ar trebui oferit mai rar. ' +
            'Focusul dietei ' + luiEi + ' ar trebui să fie ' + lightCalRec + ' ca hrană principală.';
          container.appendChild(ab);

        } else {
          // Fără info grăsime — verificăm lista de suplimente
          var fromList = isProductOkForOverweight(null, pageTitle);
          overweightBadgeDone = true;
          if (fromList) {
            overweightOk = true;
            var ab2 = document.createElement('div');
            ab2.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#fff8e1;color:#6d4c00;border:1px solid #ffe082;';
            ab2.innerHTML = '⚖️ <strong>' + r.pet.name + '</strong> are câteva kilograme în plus. ' +
              'Suplimentul poate fi oferit ocazional, dar focusul dietei ' + luiEi + ' ar trebui să fie ' + lightCalRec + '.';
            container.appendChild(ab2);
          } else {
            var wb2 = document.createElement('div');
            wb2.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;line-height:1.5;background:#e3f2fd;color:#0d47a1;border:1px solid #90caf9;';
            wb2.innerHTML = '⚖️ <strong>' + r.pet.name + '</strong> are câteva kilograme în plus. ' +
              'Nu am putut determina conținutul de grăsime al produsului — nu îl recomandăm până la verificare. ' +
              'Ca hrană principală îi recomandăm ' + lightCalRec + '.';
            container.appendChild(wb2);
          }
        }
      }

      // ── Potrivit (safe badge) ──
      var showSafe = r.safe &&
        (!r.isPuppy || puppyOk) &&
        (!r.isOverweight || overweightOk) &&
        !puppyBadgeDone &&
        !overweightBadgeDone;
      if (showSafe) {
        var sb = document.createElement('div');
        sb.style.cssText = 'padding:10px 16px;border-radius:8px;font-size:14px;font-weight:600;line-height:1.5;background:#e8f5e9;color:#2e7d32;border:1px solid #c8e6c9;';
        sb.innerHTML = '✓ ' + potrivit + ' pentru ' + r.pet.name;
        container.appendChild(sb);
      }
    });

    if (container.children.length > 0) {
      titleBlock.parentNode.insertBefore(container, titleBlock.nextSibling);
    }
  }

  function autoFillCalculator(profile) {
    if (!profile.weight || !profile.activity_level) return;

    var calcSections = document.querySelectorAll('[id^="dcalc-"]');
    if (calcSections.length === 0) return;

    var sectionIds = new Set();
    calcSections.forEach(function (el) {
      var match = el.id.match(/dcalc-\w+-(.+)/);
      if (match) sectionIds.add(match[1]);
    });

    sectionIds.forEach(function (sid) {
      var nameEl = document.getElementById('dcalc-name-' + sid);
      var weightEl = document.getElementById('dcalc-weight-' + sid);
      var mealsEl = document.getElementById('dcalc-meals-' + sid);
      var actEl = document.getElementById('dcalc-activity-' + sid);
      var btnEl = document.getElementById('dcalc-btn-' + sid);

      if (nameEl && profile.name) {
        nameEl.value = profile.name;
        nameEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (weightEl && profile.weight) {
        weightEl.value = profile.weight;
        weightEl.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (mealsEl && profile.meals_per_day) {
        mealsEl.value = profile.meals_per_day;
        mealsEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (actEl && profile.activity_level) {
        actEl.value = profile.activity_level;
        actEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (btnEl) {
        setTimeout(function () { btnEl.click(); }, 100);
      }
    });
  }


  // ══════════════════════════════════════════════════════════════════════
  // COLLECTION PAGE — Badges on product cards
  // ══════════════════════════════════════════════════════════════════════

  function initCollectionPage() {
    var auth = getAuth();
    if (!auth) return;

    var isCollection = document.body.classList.contains('template-collection') ||
                       document.querySelector('.collection-products');
    if (!isCollection) return;

    fetchOwnerProfile().then(function (op) {
      if (op) syncBillingToCart(op);
    });

    api('/products/safe').then(function (data) {
      if (!data.ok) return;

      var petsData = data.pets || [];
      if (petsData.length === 0) return;

      var cards = document.querySelectorAll('[data-product-id]');
      cards.forEach(function (card) {
        var pid = card.getAttribute('data-product-id');
        var gid = pid.indexOf('gid://') === 0 ? pid : 'gid://shopify/Product/' + pid;

        var cardStyle = window.getComputedStyle(card);
        if (cardStyle.position === 'static') card.style.position = 'relative';

        // Build badge for each pet
        var badgeContainer = document.createElement('div');
        badgeContainer.style.cssText = 'position:absolute;top:8px;left:8px;z-index:2;display:flex;flex-direction:column;gap:3px;';

        petsData.forEach(function (pet) {
          var unsafePet = pet.unsafe || {};
          var badge = document.createElement('div');
          badge.style.cssText = 'padding:2px 8px;border-radius:12px;font-size:10px;font-weight:600;white-space:nowrap;';

          if (unsafePet[gid]) {
            badge.style.background = 'rgba(255,0,0,0.85)';
            badge.style.color = '#fff';
            badge.textContent = '⚠ ' + pet.name;
          } else {
            badge.style.background = 'rgba(46,125,50,0.85)';
            badge.style.color = '#fff';
            badge.textContent = '✓ ' + pet.name;
          }

          badgeContainer.appendChild(badge);
        });

        card.appendChild(badgeContainer);
      });
    });
  }


  // ══════════════════════════════════════════════════════════════════════
  // ADDRESSES PAGE — Billing card from D1
  // ══════════════════════════════════════════════════════════════════════

  function initAddressesPage() {
    // Address CRUD via Boopr API
    function getAddrData(container) {
      return {
        first_name: (container.querySelector('[name="address[first_name]"]') || {}).value || '',
        last_name: (container.querySelector('[name="address[last_name]"]') || {}).value || '',
        address1: (container.querySelector('[name="address[address1]"]') || {}).value || '',
        address2: (container.querySelector('[name="address[address2]"]') || {}).value || '',
        city: (container.querySelector('[name="address[city]"]') || {}).value || '',
        province: (container.querySelector('[name="address[province]"]') || {}).value || '',
        zip: (container.querySelector('[name="address[zip]"]') || {}).value || '',
        phone: (container.querySelector('[name="address[phone]"]') || {}).value || '',
        country: (container.querySelector('[name="address[country]"]') || {}).value || 'Romania',
      };
    }
    function saveAddr(btn, container, method, apiPath) {
      var data = getAddrData(container);
      if (!data.address1 || !data.city) { alert('Completează cel puțin adresa și orașul.'); return; }
      var origText = btn.textContent;
      btn.disabled = true; btn.textContent = 'Se salvează...';
      var auth = window.__booprAuth || {};
      fetch('https://api.boopr.ro/accounts' + apiPath, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'x-customer-id': String(auth.customer_id || ''),
          'x-customer-email': auth.customer_email || '',
          'x-customer-token': auth.token || '',
        },
        body: JSON.stringify(data),
      }).then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.ok) {
            sessionStorage.setItem('bpet_goto_tab', 'addresses');
            window.location.reload();
          } else {
            alert('Eroare: ' + (resp.error || 'necunoscută'));
            btn.disabled = false; btn.textContent = origText;
          }
        }).catch(function (e) {
          alert('Eroare de conexiune: ' + e.message);
          btn.disabled = false; btn.textContent = origText;
        });
    }
    // New address
    var newSaveBtn = document.getElementById('bpet-addr-new-save');
    if (newSaveBtn) {
      newSaveBtn.addEventListener('click', function () {
        saveAddr(newSaveBtn, document.getElementById('bpet-addr-new-real-form'), 'POST', '/addresses');
      });
    }
    // Edit address
    document.querySelectorAll('.bpet-addr-save-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.bpet-addr-edit-panel');
        var addrId = panel ? panel.getAttribute('data-addr-id') : null;
        if (!addrId) return;
        saveAddr(btn, panel, 'PUT', '/addresses/' + addrId);
      });
    });
    // Delete handled by inline script in bpet-tab-addresses.liquid

    // Billing card (existing logic)
    var billingCard = document.getElementById('bpet-addr-billing-card');
    if (!billingCard) return;

    var auth = getAuth();
    if (!auth) return;

    fetchOwnerProfile().then(function (profile) {
      if (!profile) return;

      if (profile.cui || profile.billing_address1) {
        var html = '';
        if (profile.billing_company || profile.cui) {
          html += '<div class="bpet-addr-billing-row">';
          if (profile.billing_company) html += '<strong>' + profile.billing_company + '</strong><br>';
          if (profile.cui) html += 'CUI: ' + profile.cui;
          html += '</div>';
        }
        if (profile.billing_address1) {
          var parts = [profile.billing_address1, profile.billing_city, profile.billing_county, profile.billing_zip].filter(Boolean);
          html += '<div class="bpet-addr-billing-row" style="margin-top:6px">' + parts.join(', ') + '</div>';
        }
        if (profile.billing_country) {
          html += '<div class="bpet-addr-billing-row" style="margin-top:2px;opacity:0.6;font-size:13px">' + profile.billing_country + '</div>';
        }
        html += '<a href="/account" class="bpet-addr-billing-link" onclick="' +
          "sessionStorage.setItem('bpet_goto_tab','addresses');" +
          '">Editează adresa de facturare din Adrese →</a>';
        billingCard.innerHTML = html;
        billingCard.style.display = 'block';
      } else {
        billingCard.innerHTML = '<p style="opacity:0.5;font-size:14px;margin:0">Nu ai completat CUI-ul. Adaugă datele de facturare din <a href="/account" onclick="' +
          "sessionStorage.setItem('bpet_goto_tab','addresses');" +
          '" style="color:#f4b700;font-weight:600">Adrese</a>.</p>';
        billingCard.style.display = 'block';
      }
    });
  }

  // ── Delete Account ────────────────────────────────────────────────────
  function initDeleteAccount() {
    var btn = document.getElementById('bpet-delete-account-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      // First confirmation
      var confirmed = confirm(
        'Ești sigur că vrei să ștergi contul?\n\n' +
        'Toate datele despre câini, alergii și preferințele tale vor fi șterse permanent. Această acțiune nu poate fi anulată.'
      );
      if (!confirmed) return;

      // Second confirmation
      var doubleCheck = confirm(
        'Ultima confirmare: contul tău și toate datele asociate vor fi șterse definitiv.\n\n' +
        'Apasă OK pentru a continua cu ștergerea.'
      );
      if (!doubleCheck) return;

      btn.disabled = true;
      btn.textContent = 'Se șterge contul...';

      api('/delete-account', { method: 'DELETE' }).then(function (data) {
        if (data.ok) {
          clearAllCaches();
          alert('Contul tău a fost șters cu succes. Vei fi deconectat și redirecționat.');
          window.location.href = '/account/logout';
        } else {
          alert('Eroare la ștergerea contului: ' + (data.error || 'necunoscută'));
          btn.disabled = false;
          btn.textContent = 'Șterge contul meu';
        }
      }).catch(function () {
        alert('Eroare la ștergerea contului. Te rugăm să încerci din nou.');
        btn.disabled = false;
        btn.textContent = 'Șterge contul meu';
      });
    });
  }

  // ══════════════════════════════════════════════════════════════════════
  // INIT
  // ══════════════════════════════════════════════════════════════════════

  // ── Auto-create pet from registration flow ─────────────────────────────
  function processPendingPet() {
    try {
      var raw = sessionStorage.getItem('boopr_pending_pet');
      if (!raw) return Promise.resolve(false);
      var petData = JSON.parse(raw);
      if (!petData || !petData.name) {
        sessionStorage.removeItem('boopr_pending_pet');
        return Promise.resolve(false);
      }

      // Create pet
      var allergies = petData.allergies || [];
      delete petData.allergies;

      return api('/pets', { method: 'POST', body: petData }).then(function (data) {
        if (data.ok && data.id && allergies.length > 0) {
          // Save allergies
          return api('/pets/' + data.id + '/allergies', {
            method: 'POST',
            body: { ingredient_ids: allergies }
          }).then(function () {
            sessionStorage.removeItem('boopr_pending_pet');
            return true;
          });
        }
        sessionStorage.removeItem('boopr_pending_pet');
        return data.ok;
      }).catch(function (err) {
        console.error('[boopr] Failed to create pending pet:', err);
        sessionStorage.removeItem('boopr_pending_pet');
        return false;
      });
    } catch (e) {
      sessionStorage.removeItem('boopr_pending_pet');
      return Promise.resolve(false);
    }
  }

  // ══════════════════════════════════════════════════════════════════════
  // HOME TAB — Stats + DARF Recommendations
  // ══════════════════════════════════════════════════════════════════════

  function renderHomeStats(pet) {
    var statsEl = document.getElementById('bpd-home-stats');
    if (!statsEl || !pet) return;
    var sensEl   = document.getElementById('bpd-stat-sens');
    var sensHint = document.getElementById('bpd-stat-sens-hint');
    var allergies = pet.allergies || [];
    if (sensEl) sensEl.textContent = String(allergies.length);
    if (sensHint) {
      sensHint.textContent = allergies.length > 0
        ? allergies.slice(0, 2).map(function(a) { return a.name; }).join(', ') + (allergies.length > 2 ? '...' : '')
        : 'Nicio sensibilitate';
    }

    // DARF days remaining — based on last DARF order + pet portion
    var darfNumEl  = document.getElementById('bpd-stat-darf-days');
    var darfHintEl = document.getElementById('bpd-stat-darf-hint');
    var darfBarEl  = document.getElementById('bpd-stat-darf-bar');
    var lastDarf   = window.__booprLastDarfOrder;
    if (darfNumEl && lastDarf && lastDarf.date && lastDarf.grams > 0 && pet.weight && pet.activity_level) {
      var savedProduct = getSavedDarfProduct(pet.id);
      var kcal = savedProduct ? getDarfKcal(savedProduct) : 394;
      var portion = calcPortion(pet.weight, pet.activity_level, pet.meals_per_day, kcal);
      if (portion && portion.total > 0) {
        var daysSince = Math.floor((Date.now() - new Date(lastDarf.date).getTime()) / 86400000);
        var gramsLeft = lastDarf.grams - (daysSince * portion.total);
        var daysLeft  = gramsLeft > 0 ? Math.round(gramsLeft / portion.total) : 0;
        var totalDays = Math.round(lastDarf.grams / portion.total);
        var pct = daysLeft > 0 ? Math.min(100, Math.round((daysLeft / totalDays) * 100)) : 0;
        if (darfNumEl) darfNumEl.textContent = daysLeft > 0 ? String(daysLeft) : '0';
        if (darfHintEl) {
          if (daysLeft > 0) {
            var exhaustDate = new Date(Date.now() + daysLeft * 86400000);
            var months = ['ian','feb','mar','apr','mai','iun','iul','aug','sep','oct','nov','dec'];
            darfHintEl.textContent = 'Epuizat estimat ' + exhaustDate.getDate() + ' ' + months[exhaustDate.getMonth()];
          } else {
            darfHintEl.textContent = 'Sac epuizat — recomanda!';
            darfHintEl.style.color = 'var(--red, #fd4d00)';
          }
        }
        if (darfBarEl) darfBarEl.style.width = pct + '%';
      }
    } else if (darfNumEl) {
      darfNumEl.textContent = '—';
      if (darfHintEl) darfHintEl.textContent = 'Nicio comanda DARF';
      if (darfBarEl) darfBarEl.style.width = '0%';
    }

    statsEl.style.display = 'grid';
  }

  function renderHomeWeight(pet) {
    var el = document.getElementById('bpd-home-weight');
    if (!el || !pet) return;
    api('/health/weight/' + pet.id).then(function (data) {
      var logs = (data.entries || []).slice().sort(function (a, b) { return a.logged_at - b.logged_at; });
      if (!logs.length) { el.style.display = 'none'; return; }
      var latest = logs[logs.length - 1];
      var latestKg = parseFloat(latest.weight_kg);
      var months = ['ian','feb','mar','apr','mai','iun','iul','aug','sep','oct','nov','dec'];
      var latestD = new Date(latest.logged_at * 1000);
      var latestLabel = months[latestD.getMonth()] + ' ' + latestD.getFullYear();
      var trendHtml = '';
      if (logs.length >= 2) {
        var prev = logs[logs.length - 2];
        var diff = (latestKg - parseFloat(prev.weight_kg)).toFixed(1);
        var prevD = new Date(prev.logged_at * 1000);
        var prevLabel = months[prevD.getMonth()] + ' ' + prevD.getFullYear();
        var col = diff > 0 ? '#e65100' : diff < 0 ? '#2e7d32' : '#9aa4b5';
        var arrow = diff > 0 ? '↑' : diff < 0 ? '↓' : '→';
        trendHtml = '<div style="font-size:13px;color:' + col + ';font-weight:600;margin-top:2px">' + arrow + ' ' + (diff > 0 ? '+' : '') + diff + ' kg față de ' + prevLabel + '</div>';
      }
      var sparkHtml = '';
      if (logs.length >= 2) {
        var wts = logs.map(function (l) { return parseFloat(l.weight_kg); });
        var minW = Math.min.apply(null, wts), maxW = Math.max.apply(null, wts);
        var rng = maxW - minW || 1;
        var sw = 140, sh = 44;
        var pts = wts.map(function (w, i) {
          var x = (i / (wts.length - 1)) * sw;
          var y = sh - ((w - minW) / rng) * (sh - 8) - 4;
          return x.toFixed(1) + ',' + y.toFixed(1);
        }).join(' ');
        sparkHtml = '<svg width="' + sw + '" height="' + sh + '" style="display:block;margin-top:8px"><polyline points="' + pts + '" fill="none" stroke="#44c8d8" stroke-width="2.5" stroke-linejoin="round" stroke-linecap="round"/></svg>';
      }
      el.innerHTML = '<div class="bpet-card"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#9aa4b5;margin-bottom:6px">Evoluție greutate</div><div style="display:flex;align-items:baseline;gap:6px"><span style="font-size:28px;font-weight:800;color:#073056;line-height:1">' + latestKg + '</span><span style="font-size:13px;color:#5a6980">kg</span><span style="font-size:12px;color:#9aa4b5;margin-left:4px">' + latestLabel + '</span></div>' + trendHtml + sparkHtml + '</div>';
      el.style.display = 'block';
    }).catch(function () { el.style.display = 'none'; });
  }

  // Combined health card: sensibilități + afecțiuni într-un singur card
  function renderHomeHealth(pet) {
    var el = document.getElementById('bpet-home-allergies');
    if (!el || !pet) return;

    var allergies = pet.allergies || [];
    var conditions = activeConditions || [];
    var hasAllergies = allergies.length > 0;
    var hasConditions = conditions.length > 0;

    if (!hasAllergies && !hasConditions) {
      // Empty state — CTA to fill profile
      el.innerHTML = '<div class="bpet-card" style="display:flex;align-items:center;gap:12px;cursor:pointer" id="bphc-empty">' +
        '<div style="width:36px;height:36px;border-radius:50%;background:#f0f4f8;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:18px">🐾</div>' +
        '<div><div style="font-size:13px;font-weight:700;color:#073056;margin-bottom:2px">Adaugă profil sănătate</div>' +
        '<div style="font-size:12px;color:#9aa4b5">Sensibilități și afecțiuni pentru recomandări personalizate</div></div></div>';
      el.style.display = 'block';
      var emptyCard = document.getElementById('bphc-empty');
      if (emptyCard) emptyCard.onclick = function () { switchTab('pet'); };
      return;
    }

    var allergyHtml = '';
    if (hasAllergies) {
      var badges = allergies.map(function (a) {
        return '<span class="bpet-allergy-badge">' + a.name + '</span>';
      }).join('');
      allergyHtml =
        '<div style="' + (hasConditions ? 'margin-bottom:14px;padding-bottom:14px;border-bottom:1px solid #f0f4f8' : '') + '">' +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">' +
            '<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#9aa4b5">Sensibilități</div>' +
            '<button id="bphc-edit-btn" style="font-size:11px;padding:4px 10px;background:transparent;border:1px solid rgba(7,48,86,0.2);border-radius:6px;color:#073056;cursor:pointer">Editează</button>' +
          '</div>' +
          '<div class="bpet-allergies">' + badges + '</div>' +
        '</div>';
    }

    var condHtml = '';
    if (hasConditions) {
      var condChips = conditions.map(function (c) {
        return '<span style="display:inline-flex;align-items:center;font-size:12px;font-weight:600;padding:4px 10px;background:#fff3e0;color:#e65100;border-radius:20px;border:1px solid #ffcc80">' + c.label + '</span>';
      }).join('');
      condHtml =
        '<div>' +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px">' +
            '<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.06em;color:#9aa4b5">Afecțiuni monitorizate</div>' +
            '<button id="bphc-cond-btn" style="font-size:11px;padding:4px 10px;background:transparent;border:1px solid rgba(7,48,86,0.2);border-radius:6px;color:#073056;cursor:pointer">Gestionează</button>' +
          '</div>' +
          '<div style="display:flex;flex-wrap:wrap;gap:6px">' + condChips + '</div>' +
        '</div>';
    }

    el.innerHTML = '<div class="bpet-card">' + allergyHtml + condHtml + '</div>';
    el.style.display = 'block';

    var editBtn = document.getElementById('bphc-edit-btn');
    if (editBtn) editBtn.onclick = function () { switchTab('pet'); };
    var condBtn = document.getElementById('bphc-cond-btn');
    if (condBtn) condBtn.onclick = function () { switchTab('health'); };
  }

  function renderHomeRecommendations(pet) {
    var recsEl = document.getElementById('bpet-home-recs');
    if (!recsEl || !pet) return;
    clearEl(recsEl);

    var allergenNames = (pet.allergies || []).map(function (a) {
      return stripDiacritics(a.name.toLowerCase().trim());
    });

    // Compute max fat % allowed by active conditions
    var petMaxFat = null;
    activeConditions.forEach(function (cond) {
      var limit = CONDITION_FAT_LIMITS[cond.id];
      if (limit != null) {
        petMaxFat = petMaxFat === null ? limit : Math.min(petMaxFat, limit);
      }
    });

    // Separate compatible from incompatible (allergens + condition fat limits)
    var compatible = [];
    var incompatible = [];
    var incompatReasons = {}; // prod.href → reason label
    DARF_REC_PRODUCTS.forEach(function (prod) {
      var allergenHit = prod.allergens.some(function (a) {
        var aStrip = stripDiacritics(a.toLowerCase());
        return allergenNames.some(function (n) { return n === aStrip || n.indexOf(aStrip) !== -1 || aStrip.indexOf(n) !== -1; });
      });
      var fatHit = petMaxFat !== null && prod.fat_pct != null && prod.fat_pct > petMaxFat;
      if (allergenHit) {
        incompatReasons[prod.href] = 'Conține alergen';
        incompatible.push(prod);
      } else if (fatHit) {
        incompatReasons[prod.href] = 'Grăsime ' + prod.fat_pct + '% > ' + petMaxFat + '% max';
        incompatible.push(prod);
      } else {
        compatible.push(prod);
      }
    });

    var card = document.createElement('div');
    card.className = 'bpet-card';
    card.style.marginTop = '14px';

    var ttl = document.createElement('div');
    ttl.className = 'bpet-card-title';
    ttl.style.marginBottom = '14px';
    ttl.textContent = 'DARF recomandat pentru ' + pet.name;
    card.appendChild(ttl);

    function makeGrid(products) {
      var grid = document.createElement('div');
      grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px';
      products.forEach(function (prod) {
        var isIncompat = incompatible.indexOf(prod) !== -1;
        var a = document.createElement('a');
        a.href = prod.href;
        a.style.cssText = 'display:block;text-decoration:none;border-radius:12px;border:1.5px solid ' +
          (isIncompat ? '#ffcdd2' : '#e4e8ef') + ';background:' +
          (isIncompat ? '#fff5f5' : '#fff') + ';padding:12px 14px;transition:box-shadow .15s';
        a.onmouseover = function () { a.style.boxShadow = '0 4px 16px rgba(7,48,86,.12)'; };
        a.onmouseout  = function () { a.style.boxShadow = ''; };

        var nm = document.createElement('div');
        nm.style.cssText = 'font-family:var(--fh,sans-serif);font-weight:800;font-size:14px;color:#073056;margin-bottom:4px;line-height:1.2';
        nm.textContent = prod.name;

        var pr = document.createElement('div');
        pr.style.cssText = 'font-size:12px;color:#5a6980;margin-bottom:8px';
        pr.textContent = prod.price;

        var badge = document.createElement('div');
        badge.style.cssText = 'display:inline-block;font-size:11px;font-weight:700;padding:3px 8px;border-radius:20px;background:' +
          (isIncompat ? '#ffebee' : '#e8f5e9') + ';color:' + (isIncompat ? '#b71c1c' : '#2e7d32');
        var reason = incompatReasons[prod.href];
        badge.textContent = isIncompat ? ('✕ ' + (reason || 'Incompatibil')) : '✓ Compatibil';

        a.appendChild(nm);
        a.appendChild(pr);
        a.appendChild(badge);
        grid.appendChild(a);
      });
      return grid;
    }

    if (compatible.length > 0) {
      card.appendChild(makeGrid(compatible));
    }

    if (incompatible.length > 0 && (allergenNames.length > 0 || petMaxFat !== null)) {
      var sep = document.createElement('div');
      sep.style.cssText = 'font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:#9aa4b5;margin:14px 0 8px';
      sep.textContent = 'Incompatibile pentru ' + pet.name;
      card.appendChild(sep);
      card.appendChild(makeGrid(incompatible));
    }

    recsEl.appendChild(card);
  }

  // ══════════════════════════════════════════════════════════════════════
  // CLUB TAB
  // ══════════════════════════════════════════════════════════════════════

  function initClubTab() {
    var clubPanel = document.getElementById('bpet-tab-club');
    if (!clubPanel) return;
    var slug = clubPanel.getAttribute('data-club-slug');
    if (!slug) return;

    var loadingEl = document.getElementById('bpet-club-loading');
    var contentEl = document.getElementById('bpet-club-content');
    var errorEl   = document.getElementById('bpet-club-error');

    api('/club/' + slug).then(function (data) {
      if (loadingEl) loadingEl.style.display = 'none';
      if (errorEl) errorEl.style.display = 'none';

      if (!contentEl) return;

      // Parse monthly_reward — prefer enriched data from backend (with image/handle)
      var rewardLabel = 'Cadou';
      var rewardVariants = [];
      var rewardRaw = data.monthly_reward_data || null;
      var rewardImage = (rewardRaw && rewardRaw.image_url) || null;
      var rewardHandle = (rewardRaw && rewardRaw.handle) || null;
      var rewardItems = (rewardRaw && Array.isArray(rewardRaw.items)) ? rewardRaw.items : [];
      var isMultiProduct = rewardRaw && rewardRaw.type === 'products' && rewardItems.length > 0;
      if (!rewardRaw && data.monthly_reward) {
        try {
          rewardRaw = typeof data.monthly_reward === 'string' ? JSON.parse(data.monthly_reward) : data.monthly_reward;
        } catch (e) {}
      }
      if (isMultiProduct) {
        rewardLabel = rewardItems.length + ' produse oferite';
      } else if (rewardRaw && rewardRaw.type === 'collection' && rewardRaw.collection_title) {
        rewardLabel = 'Alege un produs din colectia ' + rewardRaw.collection_title;
      } else if (rewardRaw && rewardRaw.type === 'product' && rewardRaw.product_title) {
        rewardLabel = rewardRaw.product_title;
      } else if (data.monthly_reward) {
        rewardLabel = String(data.monthly_reward);
      }
      if (rewardRaw && Array.isArray(rewardRaw.variants) && rewardRaw.variants.length > 0) {
        rewardVariants = rewardRaw.variants;
      }

      var nowMonth = new Date().toLocaleDateString('ro-RO', { month: 'long', year: 'numeric' });

      // Clear and rebuild contentEl using DOM nodes (no innerHTML for dynamic data)
      while (contentEl.firstChild) contentEl.removeChild(contentEl.firstChild);

      function mk(tag, styles, attrs) {
        var el = document.createElement(tag);
        if (styles) el.setAttribute('style', styles);
        if (attrs) { for (var k in attrs) { if (k === 'text') el.textContent = attrs[k]; else el.setAttribute(k, attrs[k]); } }
        return el;
      }

      if (data.banner_url) {
        contentEl.appendChild(mk('img', 'width:100%;max-height:180px;object-fit:cover;border-radius:var(--rl);display:block;margin-bottom:12px',
          { src: data.banner_url, alt: (data.name || slug) }));
      }

      if (data.description) {
        var benefitsCard = mk('div', 'margin-top:12px');
        benefitsCard.className = 'bpet-card';
        benefitsCard.appendChild(mk('div', 'margin-bottom:10px', { text: 'Beneficii' })).className = 'bpet-card-title';
        data.description.split('\n').filter(function (l) { return l.trim(); }).forEach(function (b) {
          var row = mk('div', 'display:flex;gap:10px;align-items:flex-start;margin-bottom:8px');
          row.appendChild(mk('span', 'width:6px;height:6px;border-radius:50%;background:#fd4d00;flex:none;margin-top:6px'));
          row.appendChild(mk('span', 'font-size:13px;color:#333', { text: b.trim() }));
          benefitsCard.appendChild(row);
        });
        contentEl.appendChild(benefitsCard);
      }

      // Cadou card
      var cadouCard = mk('div', 'margin-top:12px');
      cadouCard.className = 'bpet-card';
      var cadouTitle = mk('div', 'margin-bottom:10px', { text: 'Cadou' });
      cadouTitle.className = 'bpet-card-title';
      cadouCard.appendChild(cadouTitle);

      // Product visual block(s): compact horizontal — small image + title (no prices)
      function buildProductRow(title, imageUrl, handle) {
        var row = mk('div', 'display:flex;align-items:center;gap:12px;padding:10px;background:#fafbfc;border:1px solid #e6ebf1;border-radius:10px;margin-bottom:8px');
        if (imageUrl) {
          var img = mk('img', 'width:70px;height:70px;object-fit:contain;background:#fff;border-radius:8px;border:1px solid #ececec;flex-shrink:0',
            { src: imageUrl, alt: title });
          if (handle) {
            var link = mk('a', 'display:block;flex-shrink:0', { href: '/products/' + handle, target: '_blank', rel: 'noopener' });
            link.appendChild(img);
            row.appendChild(link);
          } else {
            row.appendChild(img);
          }
        }
        row.appendChild(mk('div', 'font-size:14px;font-weight:600;color:#073056;line-height:1.3;flex:1', { text: title }));
        return row;
      }

      if (isMultiProduct) {
        // Header line for multi-product gift
        cadouCard.appendChild(mk('div', 'font-size:13px;color:#555;margin-bottom:8px',
          { text: 'Codul tău e valid 100% off pentru oricare dintre aceste ' + rewardItems.length + ' produse:' }));
        rewardItems.forEach(function (item) {
          cadouCard.appendChild(buildProductRow(
            item.product_title || 'Produs',
            item.image_url || null,
            item.handle || null
          ));
        });
      } else {
        cadouCard.appendChild(buildProductRow(rewardLabel, rewardImage, rewardHandle));
      }

      if (data.claimed_this_month) {
        cadouCard.appendChild(mk('div', 'display:flex;align-items:center;gap:8px;color:#2e7d32;font-size:13px;font-weight:600;margin-top:10px',
          { text: 'Revendicata pentru ' + nowMonth + '. Revino luna viitoare.' }));

        if (data.claimed_code) {
          var codeBox = mk('div', 'margin-top:12px;padding:12px;background:#f4faf6;border:1.5px dashed #2e7d32;border-radius:8px');
          var claimedTitle = data.claimed_variant_title || '';
          var isDefaultVariant = !claimedTitle || String(claimedTitle).toLowerCase() === 'default title';
          var isMultiClaim = /oricare din/i.test(claimedTitle);
          var labelText = (isDefaultVariant || isMultiClaim || isMultiProduct)
            ? 'Codul tău de discount 100%:'
            : 'Cod de discount 100% pentru ' + claimedTitle + ':';
          codeBox.appendChild(mk('div', 'font-size:12px;color:#555;margin-bottom:6px', { text: labelText }));
          var codeRow = mk('div', 'display:flex;align-items:center;gap:8px');
          var codeText = mk('code', 'flex:1;font-size:15px;font-weight:700;color:#073056;background:#fff;padding:8px 10px;border-radius:6px;border:1px solid #d0d7e3;letter-spacing:0.5px',
            { text: data.claimed_code });
          var copyBtn = mk('button', 'font-size:12px;padding:6px 12px', { type: 'button', text: 'Copiaza' });
          copyBtn.className = 'bpet-btn';
          copyBtn.addEventListener('click', function () {
            try {
              navigator.clipboard.writeText(data.claimed_code);
              copyBtn.textContent = 'Copiat';
              setTimeout(function () { copyBtn.textContent = 'Copiaza'; }, 1500);
            } catch (e) {}
          });
          codeRow.appendChild(codeText);
          codeRow.appendChild(copyBtn);
          codeBox.appendChild(codeRow);
          codeBox.appendChild(mk('div', 'font-size:11px;color:#666;margin-top:8px;line-height:1.4',
            { text: 'Aplica acest cod la checkout. E valabil doar pentru tine, single-use, pentru produsul ales.' }));
          cadouCard.appendChild(codeBox);
        }
      } else {
        cadouCard.appendChild(mk('div', 'font-size:13px;color:#555;margin-bottom:8px', { text: 'Disponibil pentru ' + nowMonth }));

        // Variant logic:
        // - Multi-product mode: no variant pick needed (code covers all)
        // - Single product mode with only "Default Title": hide selector, auto-use
        // - Single product mode with real variants: show selector
        var hasRealVariants = !isMultiProduct && (
          rewardVariants.length > 1
          || (rewardVariants.length === 1 && String(rewardVariants[0].title || '').toLowerCase() !== 'default title')
        );
        var autoVariant = (!hasRealVariants && !isMultiProduct && rewardVariants.length === 1) ? rewardVariants[0] : null;

        if (hasRealVariants) {
          var sel = mk('select', 'width:100%;padding:8px 10px;border:1.5px solid #d0d7e3;border-radius:8px;font-size:13px;color:#073056;background:#fff;margin-bottom:10px;cursor:pointer',
            { id: 'bpet-club-variant-sel' });
          var placeholder = mk('option', null, { value: '', text: '— Alege varianta —' });
          sel.appendChild(placeholder);
          rewardVariants.forEach(function (v) {
            sel.appendChild(mk('option', null, { value: String(v.id), text: String(v.title) }));
          });
          cadouCard.appendChild(sel);
        }

        var claimBtn = mk('button', 'font-size:13px', { id: 'bpet-club-claim-btn', text: 'Revendică' });
        claimBtn.className = 'bpet-btn bpet-club-claim-btn';
        cadouCard.appendChild(claimBtn);

        claimBtn.addEventListener('click', function () {
          var varSel = document.getElementById('bpet-club-variant-sel');
          if (hasRealVariants && varSel && !varSel.value) {
            varSel.style.border = '1.5px solid #fd4d00';
            varSel.focus();
            return;
          }
          claimBtn.disabled = true;
          var claimPayload = {};
          if (varSel && varSel.value) {
            claimPayload.variant_id = varSel.value;
            claimPayload.variant_title = varSel.options[varSel.selectedIndex].text;
          } else if (autoVariant) {
            claimPayload.variant_id = String(autoVariant.id);
            claimPayload.variant_title = String(autoVariant.title);
          }
          api('/club/' + slug + '/claim', { method: 'POST', body: claimPayload }).then(function (res) {
            if (res.ok) {
              var done = mk('div', 'color:#2e7d32;font-size:13px;font-weight:600;margin-top:10px',
                { text: 'Gata! Cadoul tău a fost înregistrat.' });
              claimBtn.parentNode.replaceChild(done, claimBtn);
              // Re-render cluburi section in place (fetches fresh data so code box appears)
              setTimeout(function () { initClubTab(); }, 400);
            } else {
              claimBtn.disabled = false;
              alert(res.error || 'Eroare la revendicare.');
            }
          }).catch(function () { claimBtn.disabled = false; });
        });
      }

      contentEl.appendChild(cadouCard);
      contentEl.style.display = 'block';
    }).catch(function () {
      if (loadingEl) loadingEl.style.display = 'none';
      if (errorEl) errorEl.style.display = 'block';
    });
  }

  // ══════════════════════════════════════════════════════════════════════
  // SERVICES TAB — Parteneri locali
  // ══════════════════════════════════════════════════════════════════════

  var SVC_COUNTIES = [
    { code: 'AB', name: 'Alba' },          { code: 'AR', name: 'Arad' },
    { code: 'AG', name: 'Argeș' },         { code: 'BC', name: 'Bacău' },
    { code: 'BH', name: 'Bihor' },         { code: 'BN', name: 'Bistrița-Năsăud' },
    { code: 'BT', name: 'Botoșani' },      { code: 'BV', name: 'Brașov' },
    { code: 'BR', name: 'Brăila' },        { code: 'B',  name: 'București' },
    { code: 'BZ', name: 'Buzău' },         { code: 'CS', name: 'Caraș-Severin' },
    { code: 'CL', name: 'Călărași' },      { code: 'CJ', name: 'Cluj' },
    { code: 'CT', name: 'Constanța' },     { code: 'CV', name: 'Covasna' },
    { code: 'DB', name: 'Dâmbovița' },     { code: 'DJ', name: 'Dolj' },
    { code: 'GL', name: 'Galați' },        { code: 'GR', name: 'Giurgiu' },
    { code: 'GJ', name: 'Gorj' },          { code: 'HR', name: 'Harghita' },
    { code: 'HD', name: 'Hunedoara' },     { code: 'IL', name: 'Ialomița' },
    { code: 'IS', name: 'Iași' },          { code: 'IF', name: 'Ilfov' },
    { code: 'MM', name: 'Maramureș' },     { code: 'MH', name: 'Mehedinți' },
    { code: 'MS', name: 'Mureș' },         { code: 'NT', name: 'Neamț' },
    { code: 'OT', name: 'Olt' },           { code: 'PH', name: 'Prahova' },
    { code: 'SM', name: 'Satu Mare' },     { code: 'SJ', name: 'Sălaj' },
    { code: 'SB', name: 'Sibiu' },         { code: 'SV', name: 'Suceava' },
    { code: 'TR', name: 'Teleorman' },     { code: 'TM', name: 'Timiș' },
    { code: 'TL', name: 'Tulcea' },        { code: 'VS', name: 'Vaslui' },
    { code: 'VL', name: 'Vâlcea' },        { code: 'VN', name: 'Vrancea' }
  ];

  var SVC_CATEGORIES = [
    { code: 'grooming',    name: 'Grooming',        icon: 'scissors' },
    { code: 'pet_sitting', name: 'Pet Sitting',     icon: 'paw' },
    { code: 'vet',         name: 'Veterinar',       icon: 'stethoscope' },
    { code: 'hotel',       name: 'Hotel canin',     icon: 'bed' },
    { code: 'photo',       name: 'Foto / Video',    icon: 'camera' },
    { code: 'training',    name: 'Dresaj',          icon: 'graduation' },
    { code: 'accessories', name: 'Accesorii',       icon: 'bag' },
    { code: 'play_space',  name: 'Spații de joacă', icon: 'trees' }
  ];

  function svcCountyByCode(code) {
    for (var i = 0; i < SVC_COUNTIES.length; i++) if (SVC_COUNTIES[i].code === code) return SVC_COUNTIES[i];
    return null;
  }
  function svcCategoryByCode(code) {
    for (var i = 0; i < SVC_CATEGORIES.length; i++) if (SVC_CATEGORIES[i].code === code) return SVC_CATEGORIES[i];
    return null;
  }
  function svcProvinceToCode(province) {
    if (!province) return null;
    var norm = String(province).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
    for (var i = 0; i < SVC_COUNTIES.length; i++) {
      var c = SVC_COUNTIES[i];
      var cn = c.name.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      if (norm === cn) return c.code;
    }
    if (norm === 'bucuresti' || norm === 'bucharest') return 'B';
    return null;
  }
  function svcEsc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var _svcState = { county: null, category: null, partners: [] };

  function initServicesTab() {
    var panel = document.getElementById('bpet-tab-services');
    if (!panel) return;

    // Move overlay elements out of the tab panel (escape parent stacking contexts that break position:fixed)
    // Append to the .bpet wrapper (NOT body) ca să păstreze CSS variables (--cream, --navy, etc.)
    var bpetWrap = document.querySelector('.bpet') || document.body;
    ['bpet-svc-sheet-backdrop', 'bpet-svc-sheet', 'bpet-svc-profile'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el && el.parentNode !== bpetWrap) bpetWrap.appendChild(el);
    });

    try {
      var addrs = window.__booprAddresses || [];
      var def = null;
      for (var i = 0; i < addrs.length; i++) { if (addrs[i].default) { def = addrs[i]; break; } }
      if (!def && addrs.length) def = addrs[0];
      if (def) {
        var code = svcProvinceToCode(def.province);
        if (code) _svcState.county = code;
      }
    } catch (e) { /* ignore */ }

    svcRenderChipLabels();

    var chipCounty = document.getElementById('bpet-svc-chip-county');
    var chipCategory = document.getElementById('bpet-svc-chip-category');
    if (chipCounty) chipCounty.addEventListener('click', svcOpenCountySheet);
    if (chipCategory) chipCategory.addEventListener('click', svcOpenCategorySheet);

    var sheetClose = document.getElementById('bpet-svc-sheet-close');
    var backdrop = document.getElementById('bpet-svc-sheet-backdrop');
    if (sheetClose) sheetClose.addEventListener('click', svcCloseSheet);
    if (backdrop) backdrop.addEventListener('click', svcCloseSheet);

    var pback = document.getElementById('bpet-svc-profile-back');
    if (pback) pback.addEventListener('click', svcCloseProfile);

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var prof = document.getElementById('bpet-svc-profile');
      if (prof && prof.classList.contains('open')) svcCloseProfile();
      else svcCloseSheet();
    });

    window.addEventListener('popstate', function() {
      var view = document.getElementById('bpet-svc-profile');
      if (view && view.classList.contains('open')) {
        view.classList.remove('open');
        view.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });

    svcLoadPartners();
  }

  function svcRenderChipLabels() {
    var cLab = document.querySelector('[data-svc-county-label]');
    var catLab = document.querySelector('[data-svc-category-label]');
    var chipC = document.getElementById('bpet-svc-chip-county');
    var chipCat = document.getElementById('bpet-svc-chip-category');
    if (cLab) {
      var c = svcCountyByCode(_svcState.county);
      cLab.textContent = c ? c.name : 'Toată țara';
      if (chipC) chipC.classList.toggle('is-active', !!_svcState.county);
    }
    if (catLab) {
      var cat = svcCategoryByCode(_svcState.category);
      catLab.textContent = cat ? cat.name : 'Toate';
      if (chipCat) chipCat.classList.toggle('is-active', !!_svcState.category);
    }
  }

  function svcLoadPartners() {
    var list = document.getElementById('bpet-svc-list');
    if (!list) return;
    var skel = '<div class="bpet-svc-skel-card"></div>';
    list.innerHTML = skel + skel + skel;

    var qs = [];
    if (_svcState.county) qs.push('county=' + encodeURIComponent(_svcState.county));
    if (_svcState.category) qs.push('category=' + encodeURIComponent(_svcState.category));
    var path = '/partners' + (qs.length ? '?' + qs.join('&') : '');

    fetch(API_BASE + path).then(function(r) { return r.json(); }).then(function(data) {
      _svcState.partners = (data && data.partners) || [];
      svcRenderList();
    }).catch(function() {
      svcRenderEmpty('', 'Nu am putut încărca lista', 'Încearcă din nou.');
    });
  }

  function svcRenderEmpty(icon, title, msg, withClearBtn) {
    var list = document.getElementById('bpet-svc-list');
    if (!list) return;
    var cta = withClearBtn ? '<span class="bpet-svc-empty-cta" id="bpet-svc-clear-county">Vezi în toată țara →</span>' : '';
    var iconHtml = document.createElement('div');
    iconHtml.className = 'bpet-svc-empty';
    var titleEl = document.createElement('div'); titleEl.className = 'bpet-svc-empty-title'; titleEl.textContent = title;
    var msgEl = document.createElement('div'); msgEl.textContent = msg;
    var iEl = document.createElement('div'); iEl.className = 'bpet-svc-empty-icon'; iEl.textContent = icon;
    iconHtml.appendChild(iEl);
    iconHtml.appendChild(titleEl);
    iconHtml.appendChild(msgEl);
    if (withClearBtn) {
      var ctaEl = document.createElement('span'); ctaEl.className = 'bpet-svc-empty-cta'; ctaEl.id = 'bpet-svc-clear-county'; ctaEl.textContent = 'Vezi în toată țara →';
      iconHtml.appendChild(ctaEl);
      ctaEl.addEventListener('click', function() { _svcState.county = null; svcRenderChipLabels(); svcLoadPartners(); });
    }
    list.replaceChildren(iconHtml);
  }

  function svcRenderList() {
    var list = document.getElementById('bpet-svc-list');
    if (!list) return;
    if (!_svcState.partners.length) {
      var cn = svcCountyByCode(_svcState.county);
      var msg = cn ? ('Încă nu avem parteneri în ' + cn.name + '.') : 'Niciun partener disponibil.';
      svcRenderEmpty('', msg, 'Verificăm constant noi parteneri.', !!cn);
      return;
    }
    list.replaceChildren();
    _svcState.partners.forEach(function(p) {
      list.appendChild(svcBuildCardEl(p));
    });
  }

  function svcBuildCardEl(p) {
    var cat = svcCategoryByCode(p.category);
    var card = document.createElement('button');
    card.type = 'button'; card.className = 'bpet-svc-card';
    card.setAttribute('data-id', p.id);

    var logo = document.createElement('div'); logo.className = 'bpet-svc-card-logo';
    if (p.logo_url) {
      var img = document.createElement('img'); img.src = p.logo_url; img.alt = p.name; logo.appendChild(img);
    } else {
      logo.textContent = (p.name || '?').charAt(0).toUpperCase();
    }

    var body = document.createElement('div'); body.className = 'bpet-svc-card-body';
    var n = document.createElement('div'); n.className = 'bpet-svc-card-name'; n.textContent = p.name;
    var meta = document.createElement('div'); meta.className = 'bpet-svc-card-meta';
    meta.textContent = cat ? cat.name : p.category;
    if (p.city) {
      var dot = document.createElement('span'); dot.className = 'dot'; dot.textContent = '•';
      var city = document.createElement('span'); city.textContent = p.city;
      meta.appendChild(dot); meta.appendChild(city);
    }
    body.appendChild(n); body.appendChild(meta);

    var arrow = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    arrow.setAttribute('class', 'bpet-svc-card-arrow');
    arrow.setAttribute('width', '18'); arrow.setAttribute('height', '18');
    arrow.setAttribute('viewBox', '0 0 24 24'); arrow.setAttribute('fill', 'none');
    arrow.setAttribute('stroke', 'currentColor'); arrow.setAttribute('stroke-width', '2');
    arrow.setAttribute('stroke-linecap', 'round'); arrow.setAttribute('stroke-linejoin', 'round');
    var pl = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    pl.setAttribute('points', '9 18 15 12 9 6'); arrow.appendChild(pl);

    card.appendChild(logo); card.appendChild(body); card.appendChild(arrow);
    card.addEventListener('click', function() { svcOpenProfile(p.id); });
    return card;
  }

  // ── Bottom sheet ────────────────────────────────────────────────
  function svcOpenSheet(title, items, currentValue, onPick, withSearch) {
    var backdrop = document.getElementById('bpet-svc-sheet-backdrop');
    var sheet = document.getElementById('bpet-svc-sheet');
    var titleEl = document.getElementById('bpet-svc-sheet-title');
    var listEl = document.getElementById('bpet-svc-sheet-list');
    var searchWrap = document.getElementById('bpet-svc-sheet-search-wrap');
    var searchInput = document.getElementById('bpet-svc-sheet-search');
    if (!sheet || !listEl) return;
    titleEl.textContent = title;
    searchWrap.style.display = withSearch ? 'block' : 'none';
    if (withSearch && searchInput) searchInput.value = '';

    function render(filter) {
      var f = (filter || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
      listEl.replaceChildren();
      items.forEach(function(it) {
        var ln = it.name.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        if (f && ln.indexOf(f) === -1) return;
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'bpet-svc-sheet-item' + (it.value === currentValue ? ' selected' : '');
        b.setAttribute('data-value', it.value == null ? '' : it.value);
        if (it.icon) {
          var ic = svcIconEl(it.icon); ic.setAttribute('width', '20'); ic.setAttribute('height', '20');
          ic.style.flexShrink = '0'; ic.style.opacity = '0.7'; b.appendChild(ic);
        }
        var lbl = document.createElement('span'); lbl.textContent = it.name; b.appendChild(lbl);
        var check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        check.setAttribute('class', 'check'); check.setAttribute('width', '18'); check.setAttribute('height', '18');
        check.setAttribute('viewBox', '0 0 24 24'); check.setAttribute('fill', 'none');
        check.setAttribute('stroke', 'currentColor'); check.setAttribute('stroke-width', '2.5');
        check.setAttribute('stroke-linecap', 'round'); check.setAttribute('stroke-linejoin', 'round');
        var pl = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        pl.setAttribute('points', '20 6 9 17 4 12'); check.appendChild(pl);
        b.appendChild(check);
        b.addEventListener('click', function() {
          var v = b.getAttribute('data-value');
          svcCloseSheet();
          onPick(v === '' ? null : v);
        });
        listEl.appendChild(b);
      });
      if (!listEl.children.length) {
        var em = document.createElement('div'); em.className = 'bpet-svc-empty'; em.style.padding = '32px 16px';
        var emi = document.createElement('div'); emi.className = 'bpet-svc-empty-icon'; emi.textContent = '';
        em.appendChild(emi); em.appendChild(document.createTextNode('Niciun rezultat'));
        listEl.appendChild(em);
      }
    }
    render('');
    if (withSearch && searchInput) {
      searchInput.oninput = null;
      var onSearch = function() { render(searchInput.value); };
      searchInput.oninput = onSearch;
      searchInput.addEventListener('input', onSearch);
      searchInput.addEventListener('keyup', onSearch);
    }

    backdrop.classList.add('open');
    sheet.classList.add('open');
    document.body.style.overflow = 'hidden';

    svcAdjustSheetForKeyboard();
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', svcAdjustSheetForKeyboard);
      window.visualViewport.addEventListener('resize', svcAdjustSheetForKeyboard);
    }
  }

  function svcAdjustSheetForKeyboard() {
    var sheet = document.getElementById('bpet-svc-sheet');
    if (!sheet || !sheet.classList.contains('open')) return;
    var vv = window.visualViewport;
    if (!vv) return;
    var offsetBottom = window.innerHeight - vv.height - vv.offsetTop;
    sheet.style.bottom = Math.max(0, offsetBottom) + 'px';
    sheet.style.maxHeight = Math.max(280, vv.height * 0.85) + 'px';
  }

  function svcCloseSheet() {
    var backdrop = document.getElementById('bpet-svc-sheet-backdrop');
    var sheet = document.getElementById('bpet-svc-sheet');
    if (backdrop) backdrop.classList.remove('open');
    if (sheet) { sheet.classList.remove('open'); sheet.style.bottom = ''; sheet.style.maxHeight = ''; }
    var prof = document.getElementById('bpet-svc-profile');
    if (!prof || !prof.classList.contains('open')) document.body.style.overflow = '';
    if (window.visualViewport) window.visualViewport.removeEventListener('resize', svcAdjustSheetForKeyboard);
  }

  function svcOpenCountySheet() {
    var items = [{ value: '', name: 'Toată țara', icon: 'globe' }];
    SVC_COUNTIES.forEach(function(c) { items.push({ value: c.code, name: c.name }); });
    svcOpenSheet('Alege județul', items, _svcState.county, function(v) {
      _svcState.county = v || null; svcRenderChipLabels(); svcLoadPartners();
    }, true);
  }

  function svcOpenCategorySheet() {
    var items = [{ value: '', name: 'Toate categoriile', icon: 'filter-lines' }];
    SVC_CATEGORIES.forEach(function(c) { items.push({ value: c.code, name: c.name, icon: c.icon }); });
    svcOpenSheet('Categorie serviciu', items, _svcState.category, function(v) {
      _svcState.category = v || null; svcRenderChipLabels(); svcLoadPartners();
    }, false);
  }

  // ── Profile push-view ───────────────────────────────────────────
  function svcOpenProfile(id) {
    var view = document.getElementById('bpet-svc-profile');
    var body = document.getElementById('bpet-svc-profile-body');
    if (!view || !body) return;
    body.replaceChildren();
    var spinner = document.createElement('div');
    spinner.style.cssText = 'padding:48px 24px;text-align:center';
    var sp = document.createElement('div');
    sp.style.cssText = 'width:32px;height:32px;border:3px solid #e0e0e0;border-top-color:var(--navy);border-radius:50%;animation:bpet-spin 0.8s linear infinite;margin:0 auto';
    spinner.appendChild(sp);
    body.appendChild(spinner);

    view.classList.add('open');
    view.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    history.pushState({ svcProfile: id }, '', '#partner-' + id);

    fetch(API_BASE + '/partners/' + encodeURIComponent(id)).then(function(r) { return r.json(); }).then(function(data) {
      if (!data || !data.ok || !data.partner) {
        svcRenderProfileError('', 'Profil indisponibil');
        return;
      }
      svcRenderProfile(data.partner);
    }).catch(function() { svcRenderProfileError('', 'Eroare de rețea'); });
  }

  function svcRenderProfileError(icon, title) {
    var body = document.getElementById('bpet-svc-profile-body');
    if (!body) return;
    var wrap = document.createElement('div'); wrap.className = 'bpet-svc-empty'; wrap.style.marginTop = '40px';
    var i = document.createElement('div'); i.className = 'bpet-svc-empty-icon'; i.textContent = icon;
    var t = document.createElement('div'); t.className = 'bpet-svc-empty-title'; t.textContent = title;
    wrap.appendChild(i); wrap.appendChild(t);
    body.replaceChildren(wrap);
  }

  function svcRenderProfile(p) {
    var body = document.getElementById('bpet-svc-profile-body');
    if (!body) return;
    body.replaceChildren();

    // Cover + logo overlap
    var cover = document.createElement('div'); cover.className = 'bpet-svc-profile-cover';
    if (p.cover_url) cover.style.backgroundImage = "url('" + String(p.cover_url).replace(/'/g, "\\'") + "')";
    var logoBox = document.createElement('div'); logoBox.className = 'bpet-svc-profile-logo';
    if (p.logo_url) {
      var img = document.createElement('img'); img.src = p.logo_url; img.alt = p.name; logoBox.appendChild(img);
    } else { logoBox.textContent = (p.name || '?').charAt(0).toUpperCase(); }
    cover.appendChild(logoBox);
    body.appendChild(cover);

    // Name + category + city tags
    var meta = document.createElement('div'); meta.className = 'bpet-svc-profile-meta';
    var name = document.createElement('h2'); name.className = 'bpet-svc-profile-name'; name.textContent = p.name;
    var tags = document.createElement('div'); tags.className = 'bpet-svc-profile-tags';
    var cat = svcCategoryByCode(p.category);
    var catTag = document.createElement('span'); catTag.className = 'bpet-svc-profile-tag';
    if (cat) {
      catTag.style.display = 'inline-flex'; catTag.style.alignItems = 'center'; catTag.style.gap = '5px';
      var cIc = svcIconEl(cat.icon); cIc.setAttribute('width', '14'); cIc.setAttribute('height', '14');
      catTag.appendChild(cIc); catTag.appendChild(document.createTextNode(cat.name));
    } else {
      catTag.textContent = p.category;
    }
    tags.appendChild(catTag);
    if (p.city) {
      var ct = document.createElement('span'); ct.className = 'bpet-svc-profile-tag';
      ct.style.display = 'inline-flex'; ct.style.alignItems = 'center'; ct.style.gap = '5px';
      var pIc = svcIconEl('pin'); pIc.setAttribute('width', '14'); pIc.setAttribute('height', '14');
      ct.appendChild(pIc); ct.appendChild(document.createTextNode(p.city));
      tags.appendChild(ct);
    }
    meta.appendChild(name); meta.appendChild(tags);
    body.appendChild(meta);

    // Socials icon row (right under name, like Insta/FB profile)
    var hasSocials = !!(p.instagram || p.facebook || p.tiktok);
    if (hasSocials) {
      var socials = document.createElement('div'); socials.className = 'bpet-svc-socials';
      if (p.instagram) socials.appendChild(svcSocialIconEl('ig', svcSocialUrl('ig', p.instagram), 'Instagram'));
      if (p.facebook)  socials.appendChild(svcSocialIconEl('fb', svcSocialUrl('fb', p.facebook), 'Facebook'));
      if (p.tiktok)    socials.appendChild(svcSocialIconEl('tt', svcSocialUrl('tt', p.tiktok), 'TikTok'));
      body.appendChild(socials);
    }

    // Description (inline, no card)
    if (p.description) {
      var desc = document.createElement('div'); desc.className = 'bpet-svc-profile-desc';
      desc.textContent = p.description;
      body.appendChild(desc);
    }

    // Address (compact, before CTA)
    if (p.address) {
      var addr = document.createElement('a'); addr.className = 'bpet-svc-profile-address';
      addr.href = 'https://maps.google.com/?q=' + encodeURIComponent(p.address);
      addr.target = '_blank'; addr.rel = 'noopener';
      var pin = svcSvgEl(['path', { d: 'M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z' }], ['circle', { cx: 12, cy: 10, r: 3 }]);
      pin.setAttribute('width', '16'); pin.setAttribute('height', '16');
      addr.appendChild(pin);
      var at = document.createElement('span'); at.className = 'addr-text'; at.textContent = p.address;
      addr.appendChild(at);
      body.appendChild(addr);
    }

    // Contact actions — pick primary by priority: website > phone > email
    var contactBuilders = {
      website: function() {
        return { href: p.website, ext: true, icon: 'globe', primary: 'Vezi website', secondary: 'Website' };
      },
      phone: function() {
        return { href: 'tel:' + String(p.phone).replace(/\s+/g, ''), ext: false, icon: 'phone', primary: 'Sună ' + p.phone, secondary: 'Sună' };
      },
      email: function() {
        return { href: 'mailto:' + p.email, ext: false, icon: 'mail', primary: 'Trimite email', secondary: 'Email' };
      }
    };
    var available = [];
    if (p.website) available.push('website');
    if (p.phone) available.push('phone');
    if (p.email) available.push('email');

    if (available.length) {
      var primary = contactBuilders[available[0]]();
      var cta = document.createElement('a'); cta.className = 'bpet-svc-cta-primary';
      cta.href = primary.href;
      if (primary.ext) { cta.target = '_blank'; cta.rel = 'noopener noreferrer'; }
      var ctaIcon = svcIconEl(primary.icon);
      ctaIcon.setAttribute('width', '18'); ctaIcon.setAttribute('height', '18');
      var ctaLab = document.createElement('span'); ctaLab.textContent = primary.primary;
      cta.appendChild(ctaIcon); cta.appendChild(ctaLab);
      body.appendChild(cta);

      // Restul în rândul secondary — auto full-width dacă rămâne unul singur
      var rest = available.slice(1);
      if (rest.length) {
        var secondary = document.createElement('div'); secondary.className = 'bpet-svc-secondary-row';
        rest.forEach(function(k) {
          var b = contactBuilders[k]();
          var a = document.createElement('a'); a.className = 'bpet-svc-secondary';
          a.href = b.href;
          if (b.ext) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
          var ic = svcIconEl(b.icon); ic.setAttribute('width', '15'); ic.setAttribute('height', '15');
          var l = document.createElement('span'); l.textContent = b.secondary;
          a.appendChild(ic); a.appendChild(l);
          secondary.appendChild(a);
        });
        body.appendChild(secondary);
      }
    }
  }

  function svcSocialIconEl(net, url, label) {
    var a = document.createElement('a'); a.className = 'bpet-svc-social ' + net;
    a.href = url; a.target = '_blank'; a.rel = 'noopener noreferrer';
    a.setAttribute('aria-label', label);
    var icon = svcIconEl(net === 'ig' ? 'instagram' : net === 'fb' ? 'facebook' : 'tiktok');
    icon.setAttribute('width', '17'); icon.setAttribute('height', '17');
    a.appendChild(icon);
    return a;
  }

  function svcActionEl(href, title, sub, iconName, external) {
    var a = document.createElement('a'); a.className = 'bpet-svc-action'; a.href = href;
    if (external) { a.target = '_blank'; a.rel = 'noopener noreferrer'; }
    var iw = document.createElement('span'); iw.className = 'bpet-svc-action-icon';
    iw.appendChild(svcIconEl(iconName));
    var lab = document.createElement('span'); lab.style.cssText = 'display:flex;flex-direction:column;gap:2px;min-width:0;flex:1';
    var t = document.createElement('span'); t.style.fontWeight = '700'; t.textContent = title;
    var s = document.createElement('span'); s.style.cssText = 'font-size:0.82rem;color:#707481;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis'; s.textContent = sub;
    lab.appendChild(t); lab.appendChild(s);
    var ar = svcSvgEl(['polyline', { points: '9 18 15 12 9 6' }]);
    ar.setAttribute('class', 'bpet-svc-action-arrow');
    a.appendChild(iw); a.appendChild(lab); a.appendChild(ar);
    return a;
  }

  function svcSvgEl() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '18'); svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor'); svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round'); svg.setAttribute('stroke-linejoin', 'round');
    for (var i = 0; i < arguments.length; i++) {
      var spec = arguments[i];
      var el = document.createElementNS('http://www.w3.org/2000/svg', spec[0]);
      var attrs = spec[1] || {};
      for (var k in attrs) el.setAttribute(k, attrs[k]);
      svg.appendChild(el);
    }
    return svg;
  }

  function svcIconEl(name) {
    if (name === 'phone') return svcSvgEl(['path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.33 1.85.57 2.81.7A2 2 0 0 1 22 16.92z' }]);
    if (name === 'globe') return svcSvgEl(['circle', { cx: 12, cy: 12, r: 10 }], ['line', { x1: 2, y1: 12, x2: 22, y2: 12 }], ['path', { d: 'M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z' }]);
    if (name === 'instagram') return svcSvgEl(['rect', { x: 2, y: 2, width: 20, height: 20, rx: 5, ry: 5 }], ['path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' }], ['line', { x1: 17.5, y1: 6.5, x2: 17.51, y2: 6.5 }]);
    if (name === 'facebook') return svcSvgEl(['path', { d: 'M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z' }]);
    if (name === 'tiktok') {
      var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      s.setAttribute('width', '18'); s.setAttribute('height', '18'); s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('fill', 'currentColor');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M19.6 6.3a4.8 4.8 0 0 1-3.2-1.4 4.6 4.6 0 0 1-1.4-3H12v12.6a2.8 2.8 0 1 1-2-2.7V8.5a6 6 0 1 0 5 5.9V9.6a7.5 7.5 0 0 0 4.6 1.5z');
      s.appendChild(p); return s;
    }
    if (name === 'mail') return svcSvgEl(['path', { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' }], ['polyline', { points: '22,6 12,13 2,6' }]);
    if (name === 'scissors') return svcSvgEl(['circle', { cx: 6, cy: 6, r: 3 }], ['circle', { cx: 6, cy: 18, r: 3 }], ['line', { x1: 20, y1: 4, x2: 8.12, y2: 15.88 }], ['line', { x1: 14.47, y1: 14.48, x2: 20, y2: 20 }], ['line', { x1: 8.12, y1: 8.12, x2: 12, y2: 12 }]);
    if (name === 'paw') return svcSvgEl(['circle', { cx: 11, cy: 4, r: 2 }], ['circle', { cx: 18, cy: 8, r: 2 }], ['circle', { cx: 20, cy: 16, r: 2 }], ['path', { d: 'M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10z' }]);
    if (name === 'stethoscope') return svcSvgEl(['path', { d: 'M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3' }], ['path', { d: 'M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4' }], ['circle', { cx: 20, cy: 10, r: 2 }]);
    if (name === 'bed') return svcSvgEl(['path', { d: 'M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8' }], ['path', { d: 'M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4' }], ['path', { d: 'M12 4v6' }], ['line', { x1: 2, y1: 18, x2: 22, y2: 18 }]);
    if (name === 'camera') return svcSvgEl(['path', { d: 'M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z' }], ['circle', { cx: 12, cy: 13, r: 3 }]);
    if (name === 'graduation') return svcSvgEl(['path', { d: 'M22 10 12 5 2 10l10 5z' }], ['path', { d: 'M6 12v5c0 1.66 2.69 3 6 3s6-1.34 6-3v-5' }], ['line', { x1: 22, y1: 10, x2: 22, y2: 16 }]);
    if (name === 'bag') return svcSvgEl(['path', { d: 'M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z' }], ['line', { x1: 3, y1: 6, x2: 21, y2: 6 }], ['path', { d: 'M16 10a4 4 0 0 1-8 0' }]);
    if (name === 'trees') return svcSvgEl(['path', { d: 'M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0z' }], ['line', { x1: 7, y1: 16, x2: 7, y2: 22 }], ['line', { x1: 13, y1: 19, x2: 13, y2: 22 }], ['path', { d: 'M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5' }]);
    if (name === 'filter-lines') return svcSvgEl(['line', { x1: 3, y1: 6, x2: 21, y2: 6 }], ['line', { x1: 6, y1: 12, x2: 18, y2: 12 }], ['line', { x1: 10, y1: 18, x2: 14, y2: 18 }]);
    if (name === 'pin') return svcSvgEl(['path', { d: 'M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z' }], ['circle', { cx: 12, cy: 10, r: 3 }]);
    return svcSvgEl();
  }

  function svcCleanUrl(url) { return String(url).replace(/^https?:\/\//, '').replace(/\/$/, ''); }
  function svcCleanFb(v) { return String(v).replace(/^https?:\/\/(www\.)?facebook\.com\//, '@').replace(/\/$/, ''); }
  function svcSocialUrl(net, handle) {
    var h = String(handle).trim();
    if (/^https?:\/\//.test(h)) return h;
    h = h.replace(/^@/, '');
    if (net === 'ig') return 'https://instagram.com/' + h;
    if (net === 'fb') return 'https://facebook.com/' + h;
    if (net === 'tt') return 'https://tiktok.com/@' + h;
    return h;
  }

  function svcCloseProfile() {
    var view = document.getElementById('bpet-svc-profile');
    if (!view) return;
    view.classList.remove('open');
    view.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (history.state && history.state.svcProfile) history.back();
  }

  // ══════════════════════════════════════════════════════════════════════
  // HEALTH TAB — Weight Tracking
  // ══════════════════════════════════════════════════════════════════════

  function initHealthTab(pet) {
    if (!pet) return;

    // Update pet name in header
    var nameEl = document.getElementById('bpd-health-pet-name');
    if (nameEl) nameEl.textContent = pet.name || '—';

    // Load diagnostics + re-render home recs (must happen regardless of form DOM state)
    activeConditions = [];
    api('/health/conditions/' + pet.id).then(function (data) {
      activeConditions = (data.conditions || []).map(function (c) {
        return { id: c.condition_id, label: c.label, rowId: c.id };
      });
      renderDiagPanel(pet.id);
      renderHomeHealth(pet);
      renderHomeRecommendations(pet);
    }).catch(function () {
      renderDiagPanel(pet.id);
      renderHomeHealth(pet);
      renderHomeRecommendations(pet);
    });

    // Weight form setup — only if DOM elements exist
    var form = document.getElementById('bpd-weight-form');
    var addBtn = document.getElementById('bpd-weight-add-btn');
    var kgIn = document.getElementById('bpd-weight-kg-in');
    var dateIn = document.getElementById('bpd-weight-date-in');
    var saveBtn = document.getElementById('bpd-weight-save-btn');
    var cancelBtn = document.getElementById('bpd-weight-cancel-btn');
    if (!form || !addBtn) return;

    // Set today as default date
    if (dateIn) {
      var today = new Date();
      var yyyy = today.getFullYear();
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var dd = String(today.getDate()).padStart(2, '0');
      dateIn.value = yyyy + '-' + mm + '-' + dd;
    }

    // Rebind show/hide form
    addBtn.onclick = function () {
      form.style.display = form.style.display === 'none' ? '' : 'none';
      if (kgIn) kgIn.focus();
    };
    if (cancelBtn) cancelBtn.onclick = function () { form.style.display = 'none'; };

    // Rebind save
    if (saveBtn) {
      saveBtn.onclick = function () { saveWeightEntry(pet); };
    }

    // Load history
    loadWeightHistory(pet);
  }

  function renderDiagPanel(petId) {
    var tagsEl  = document.getElementById('bpd-diag-active');
    var chipsEl = document.getElementById('bpd-diag-chips');
    if (!tagsEl || !chipsEl) return;

    // Active tags
    clearEl(tagsEl);
    if (activeConditions.length === 0) {
      var none = document.createElement('span');
      none.className = 'bpd-diag-none';
      none.textContent = 'Nicio afecțiune adăugată';
      tagsEl.appendChild(none);
    } else {
      activeConditions.forEach(function (cond) {
        var tag = document.createElement('span');
        tag.className = 'bpd-diag-tag';
        tag.style.cssText = 'display:inline-flex;align-items:center;gap:6px;padding:5px 12px;background:#fff3ef;border:1.5px solid #ffdccc;border-radius:20px;font-size:13px;color:#c0392b;font-weight:600;';
        var lbl = document.createTextNode(cond.label);
        var xBtn = document.createElement('button');
        xBtn.className = 'bpd-diag-tag-x';
        xBtn.style.cssText = 'background:none;border:none;color:#c0392b;font-size:16px;cursor:pointer;padding:0;line-height:1;font-weight:700;';
        xBtn.textContent = '×';
        xBtn.title = 'Șterge';
        xBtn.setAttribute('data-rowid', cond.rowId);
        xBtn.addEventListener('click', function () {
          var rid = this.getAttribute('data-rowid');
          api('/health/conditions/' + petId + '/' + rid, { method: 'DELETE' }).then(function (r) {
            if (r && r.ok) {
              activeConditions = activeConditions.filter(function (c) { return c.rowId !== rid; });
              renderDiagPanel(petId);
            }
          });
        });
        tag.appendChild(lbl);
        tag.appendChild(xBtn);
        tagsEl.appendChild(tag);
      });
    }

    // Predefined chips
    clearEl(chipsEl);
    var existingIds = activeConditions.map(function (c) { return c.id; });
    PREDEFINED_CONDITIONS.forEach(function (cond) {
      var chip = document.createElement('button');
      chip.className = 'bpd-diag-chip' + (existingIds.indexOf(cond.id) !== -1 ? ' active' : '');
      chip.textContent = cond.label;
      chip.disabled = existingIds.indexOf(cond.id) !== -1;
      chip.style.cssText = 'padding:6px 14px;border-radius:20px;border:1.5px solid var(--border,#ede9e3);background:#fff;font-size:13px;cursor:pointer;transition:all .15s;font-family:inherit;color:#073056;';
      if (chip.disabled) chip.style.opacity = '0.5';
      chip.onmouseenter = function () { if (!chip.disabled) { chip.style.borderColor = '#fd4d00'; chip.style.background = '#fff3ef'; } };
      chip.onmouseleave = function () { if (!chip.disabled) { chip.style.borderColor = 'var(--border,#ede9e3)'; chip.style.background = '#fff'; } };
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        chip.disabled = true;
        api('/health/conditions/' + petId, { method: 'POST', body: { condition_id: cond.id, label: cond.label } }).then(function (r) {
          if (r && r.ok) {
            activeConditions.push({ id: cond.id, label: cond.label, rowId: String(r.id) });
            renderDiagPanel(petId);
          } else {
            chip.disabled = false;
          }
        }).catch(function () { chip.disabled = false; });
      });
      chipsEl.appendChild(chip);
    });

    // Custom add
    var customIn  = document.getElementById('bpd-diag-custom-in');
    var customAdd = document.getElementById('bpd-diag-custom-add');
    if (customAdd) {
      customAdd.onclick = function () {
        var val = customIn ? customIn.value.trim() : '';
        if (!val) return;
        api('/health/conditions/' + petId, { method: 'POST', body: { condition_id: 'custom_' + Date.now(), label: val } }).then(function (r) {
          if (r && r.ok) {
            activeConditions.push({ id: 'custom_' + Date.now(), label: val, rowId: String(r.id) });
            if (customIn) customIn.value = '';
            renderDiagPanel(petId);
          }
        });
      };
    }
  }

  function loadWeightHistory(pet) {
    var loadEl = document.getElementById('bpd-health-loading');
    var histEl = document.getElementById('bpd-weight-history');
    var statusEl = document.getElementById('bpd-weight-status');
    if (loadEl) loadEl.style.display = 'block';
    if (histEl) histEl.style.display = 'none';
    if (statusEl) statusEl.style.display = 'none';

    api('/health/weight/' + pet.id).then(function (data) {
      if (loadEl) loadEl.style.display = 'none';
      var entries = (data && data.entries) ? data.entries : [];
      renderWeightHistory(entries, pet);
      var latest = entries.length > 0 ? parseFloat(entries[0].weight_kg) : null;
      renderWeightStatus(pet, latest);
    }).catch(function () {
      if (loadEl) { loadEl.style.display = 'block'; loadEl.textContent = 'Eroare la încărcare.'; }
    });
  }

  function renderWeightHistory(entries, pet) {
    var histEl = document.getElementById('bpd-weight-history');
    var listEl = document.getElementById('bpd-weight-list');
    var wEl = document.getElementById('bpd-health-weight');
    if (!histEl || !listEl) return;

    // Clear previous content
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);

    if (entries.length === 0) {
      histEl.style.display = 'block';
      var noneMsg = document.createElement('div');
      noneMsg.style.cssText = 'font-size:13px;color:var(--t3);padding:4px 0';
      noneMsg.textContent = 'Nicio cântărire înregistrată';
      listEl.appendChild(noneMsg);
      if (wEl) wEl.textContent = '—';
      return;
    }

    histEl.style.display = 'block';
    if (wEl) wEl.textContent = entries[0].weight_kg + ' kg';

    // SVG chart (entries come DESC from API → reverse to get ASC for chart)
    if (entries.length >= 2) {
      var pts = entries.slice().reverse();
      var W = 560, H = 110, PL = 38, PR = 12, PT = 14, PB = 26;
      var iW = W - PL - PR;
      var iH = H - PT - PB;
      var minW = pts.reduce(function (m, p) { return Math.min(m, parseFloat(p.weight_kg)); }, Infinity);
      var maxW = pts.reduce(function (m, p) { return Math.max(m, parseFloat(p.weight_kg)); }, -Infinity);
      var range = maxW - minW || 1;
      minW = minW - range * 0.15;
      maxW = maxW + range * 0.15;
      range = maxW - minW;
      var n = pts.length;

      function cx(i) { return PL + (i / (n - 1)) * iW; }
      function cy(w) { return PT + iH - ((w - minW) / range) * iH; }

      var pointCoords = pts.map(function (p, i) {
        return cx(i).toFixed(1) + ',' + cy(parseFloat(p.weight_kg)).toFixed(1);
      });
      var polylinePoints = pointCoords.join(' ');

      // Area fill path
      var firstX = cx(0).toFixed(1);
      var lastX = cx(n - 1).toFixed(1);
      var bottomY = (PT + iH).toFixed(1);
      var areaPath = 'M ' + firstX + ',' + bottomY +
        ' L ' + pointCoords.join(' L ') +
        ' L ' + lastX + ',' + bottomY + ' Z';

      // Y-axis labels
      var yLabels = '';
      var ySteps = [minW + range * 0.1, minW + range * 0.5, minW + range * 0.9];
      ySteps.forEach(function (val) {
        yLabels += '<text x="' + (PL - 4) + '" y="' + (cy(val) + 4).toFixed(1) + '" ' +
          'text-anchor="end" font-size="9" fill="#9aa4b5">' + val.toFixed(1) + '</text>';
      });

      // X-axis date labels (first + last)
      function fmtDate(s) {
        var d = new Date(s);
        return (d.getDate()) + '/' + (d.getMonth() + 1);
      }
      var xLabels = '<text x="' + cx(0).toFixed(1) + '" y="' + (PT + iH + 14) + '" ' +
        'text-anchor="middle" font-size="9" fill="#9aa4b5">' + fmtDate(pts[0].logged_at) + '</text>' +
        '<text x="' + cx(n - 1).toFixed(1) + '" y="' + (PT + iH + 14) + '" ' +
        'text-anchor="middle" font-size="9" fill="#9aa4b5">' + fmtDate(pts[n - 1].logged_at) + '</text>';

      // Dots
      var dots = pts.map(function (p, i) {
        return '<circle cx="' + cx(i).toFixed(1) + '" cy="' + cy(parseFloat(p.weight_kg)).toFixed(1) + '" ' +
          'r="3" fill="#073056"/>';
      }).join('');

      var svgHtml = '<svg viewBox="0 0 ' + W + ' ' + H + '" style="width:100%;display:block;margin-bottom:8px" xmlns="http://www.w3.org/2000/svg">' +
        '<defs><linearGradient id="wGrad" x1="0" y1="0" x2="0" y2="1">' +
        '<stop offset="0%" stop-color="#073056" stop-opacity="0.18"/>' +
        '<stop offset="100%" stop-color="#073056" stop-opacity="0"/>' +
        '</linearGradient></defs>' +
        '<path d="' + areaPath + '" fill="url(#wGrad)"/>' +
        '<polyline points="' + polylinePoints + '" fill="none" stroke="#073056" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
        dots + yLabels + xLabels +
        '</svg>';

      var svgWrap = document.createElement('div');
      svgWrap.innerHTML = svgHtml;
      listEl.appendChild(svgWrap.firstChild);
    }

    // List rows
    entries.forEach(function (e) {
      var row = document.createElement('div');
      row.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:6px 0;border-bottom:1px solid var(--border);font-size:13px';
      var d = new Date(e.logged_at);
      var dateStr = d.toLocaleDateString('ro-RO', { day: 'numeric', month: 'short', year: 'numeric' });
      var left = document.createElement('div');
      left.innerHTML = '<strong>' + e.weight_kg + ' kg</strong><span style="color:var(--t3);margin-left:8px">' + dateStr + '</span>';
      var delBtn = document.createElement('button');
      delBtn.textContent = '×';
      delBtn.title = 'Șterge';
      delBtn.style.cssText = 'background:none;border:none;color:#c00;font-size:16px;cursor:pointer;padding:2px 6px;line-height:1';
      delBtn.setAttribute('data-id', e.id);
      delBtn.setAttribute('data-pet', pet.id);
      delBtn.onclick = function () {
        var entryId = this.getAttribute('data-id');
        var petId = this.getAttribute('data-pet');
        api('/health/weight/' + petId + '/' + entryId, { method: 'DELETE' }).then(function (r) {
          if (r && r.ok) loadWeightHistory(pet);
        });
      };
      row.appendChild(left);
      row.appendChild(delBtn);
      listEl.appendChild(row);
    });
  }

  function renderWeightStatus(pet, measuredWeight) {
    var el = document.getElementById('bpd-weight-status');
    if (!el) return;
    var ideal = parseFloat(pet.weight);
    var w = measuredWeight != null ? parseFloat(measuredWeight) : null;
    var html, bg, border, color;

    if (!ideal || isNaN(ideal)) {
      el.style.cssText = 'display:block;margin-top:12px;padding:10px 14px;border-radius:8px;font-size:13px;background:#f5f5f5;border:1px solid #e0e0e0;color:#555';
      el.innerHTML = 'Setează <strong>greutatea ideală</strong> în tab-ul <em>Câinele meu</em> pentru a vedea statusul greutății.';
      return;
    }

    if (w === null || isNaN(w)) {
      el.style.display = 'none';
      return;
    }

    var diff = w - ideal;
    var pct = (diff / ideal) * 100;

    if (Math.abs(pct) <= 10) {
      bg = '#e8f5e9'; border = '#a5d6a7'; color = '#1b5e20';
      html = '✅ <strong>' + pet.name + '</strong> este la <strong>greutatea optimă</strong>! ' +
        '(' + w + ' kg față de ideal ' + ideal + ' kg — ' + (pct >= 0 ? '+' : '') + pct.toFixed(1) + '%)';
    } else if (pct > 10 && pct < 20) {
      bg = '#fff8e1'; border = '#ffe082'; color = '#6d4c00';
      html = '⚖️ <strong>' + pet.name + '</strong> este <strong>supraponderal</strong> (' + w + ' kg, ideal ' + ideal + ' kg, +' + pct.toFixed(1) + '%). ' +
        'Îți recomandăm <strong>DARF Light</strong> sau <strong>DARF Cal</strong> și reducerea porției cu ~10%.';
    } else if (pct >= 20) {
      bg = '#fce4ec'; border = '#f48fb1'; color = '#880e4f';
      html = '🚨 <strong>' + pet.name + '</strong> este <strong>obez</strong> (' + w + ' kg, ideal ' + ideal + ' kg, +' + pct.toFixed(1) + '%). ' +
        'Recomandăm urgent <strong>DARF Light</strong>, porție redusă și consultarea veterinarului.';
    } else if (pct < -10 && pct > -20) {
      bg = '#fff3e0'; border = '#ffcc80'; color = '#e65100';
      html = '📉 <strong>' + pet.name + '</strong> este <strong>subponderal</strong> (' + w + ' kg, ideal ' + ideal + ' kg, ' + pct.toFixed(1) + '%). ' +
        'Încearcă <strong>DARF Vită</strong> sau <strong>DARF Miel</strong> cu porție mărită.';
    } else {
      bg = '#fce4ec'; border = '#f48fb1'; color = '#880e4f';
      html = '🚨 <strong>' + pet.name + '</strong> este <strong>sever subponderal</strong> (' + w + ' kg, ideal ' + ideal + ' kg, ' + pct.toFixed(1) + '%). ' +
        'Consultați urgent veterinarul și măriți porțiile treptat.';
    }

    el.style.cssText = 'display:block;margin-top:12px;padding:10px 14px;border-radius:8px;font-size:13px;background:' + bg + ';border:1px solid ' + border + ';color:' + color;
    el.innerHTML = html;
  }

  function saveWeightEntry(pet) {
    var kgIn = document.getElementById('bpd-weight-kg-in');
    var dateIn = document.getElementById('bpd-weight-date-in');
    var saveBtn = document.getElementById('bpd-weight-save-btn');
    var form = document.getElementById('bpd-weight-form');
    if (!kgIn || !saveBtn) return;

    var kg = parseFloat(kgIn.value);
    if (!kg || kg < 0.5 || kg > 120) {
      kgIn.style.borderColor = '#c00';
      setTimeout(function () { kgIn.style.borderColor = ''; }, 2000);
      return;
    }

    var dateVal = dateIn ? dateIn.value : null;
    saveBtn.disabled = true;
    saveBtn.textContent = '...';

    api('/health/weight/' + pet.id, {
      method: 'POST',
      body: { weight_kg: kg, logged_at: dateVal || null }
    }).then(function (data) {
      if (data && data.ok) {
        kgIn.value = '';
        if (form) form.style.display = 'none';
        loadWeightHistory(pet);
      } else {
        saveBtn.textContent = 'Eroare';
        setTimeout(function () { saveBtn.textContent = 'Salvează'; }, 2000);
      }
    }).catch(function () {
      saveBtn.textContent = 'Eroare';
      setTimeout(function () { saveBtn.textContent = 'Salvează'; }, 2000);
    }).finally(function () {
      saveBtn.disabled = false;
      if (saveBtn.textContent === '...') saveBtn.textContent = 'Salvează';
    });
  }

  window.BooprLegacy = {
    initProfileEdit: initProfileEdit, initBillingToggle: initBillingToggle, initBillingForm: initBillingForm,
    initAddressForms: initAddressForms, initClubTab: initClubTab, initServicesTab: initServicesTab,
    initDeleteAccount: initDeleteAccount, fetchOwnerProfile: fetchOwnerProfile
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (!getAuth()) return;

    // Check for pending pet data from registration flow
    processPendingPet().then(function (created) {
      if (created) {
        // Force refresh to show new pet data
        clearAllCaches();
      }
      initDashboard();
      initProductPage();
      initCollectionPage();
      initAddressesPage();

      // Deep-link to tab (from sessionStorage or URL ?tab=)
      var gotoTab = sessionStorage.getItem('bpet_goto_tab');
      if (!gotoTab) {
        var urlTab = new URLSearchParams(window.location.search).get('tab');
        if (urlTab) gotoTab = urlTab;
      }
      if (gotoTab) {
        sessionStorage.removeItem('bpet_goto_tab');
        var tabBtn = document.querySelector('[data-tab="' + gotoTab + '"]');
        if (tabBtn) setTimeout(function () { tabBtn.click(); }, 100);
      }
    });
  });

})();

// ═══════════════════════════════════════════════════════════════════════════════
// ADDRESS FORMS — STANDALONE (outside IIFE, no auth dependency)
// Intercepts Shopify form submits and routes through Boopr API instead
// ═══════════════════════════════════════════════════════════════════════════════
(function() {
  function addrData(c) {
    return {
      first_name: (c.querySelector('[name="address[first_name]"]')||{}).value||'',
      last_name: (c.querySelector('[name="address[last_name]"]')||{}).value||'',
      address1: (c.querySelector('[name="address[address1]"]')||{}).value||'',
      address2: (c.querySelector('[name="address[address2]"]')||{}).value||'',
      city: (c.querySelector('[name="address[city]"]')||{}).value||'',
      province: (c.querySelector('[name="address[province]"]')||{}).value||'',
      zip: (c.querySelector('[name="address[zip]"]')||{}).value||'',
      phone: (c.querySelector('[name="address[phone]"]')||{}).value||'',
      country: (c.querySelector('[name="address[country]"]')||{}).value||'Romania',
    };
  }
  function saveAddr(btn, container, method, path) {
    var data = addrData(container);
    if (!data.address1 || !data.city) { alert('Completează cel puțin adresa și orașul.'); return; }
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Se salvează...';
    var a = window.__booprAuth || {};
    console.log('[Boopr][Addr] Saving:', method, path, data);
    fetch('https://api.boopr.ro/accounts' + path, {
      method: method,
      headers: { 'Content-Type':'application/json', 'x-customer-id':String(a.customer_id||''), 'x-customer-email':a.customer_email||'', 'x-customer-token':a.token||'' },
      body: JSON.stringify(data),
    }).then(function(r){return r.json()}).then(function(resp) {
      console.log('[Boopr][Addr] Response:', resp);
      if (resp.ok) { sessionStorage.setItem('bpet_goto_tab','addresses'); window.location.reload(); }
      else { alert('Eroare: '+(resp.error||'necunoscută')); btn.disabled=false; btn.textContent=orig; }
    }).catch(function(e) { alert('Eroare conexiune: '+e.message); btn.disabled=false; btn.textContent=orig; });
  }
  // Intercept form submits in address containers (capture phase)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.closest) return;
    // New address
    if (form.closest('#bpet-addr-new-form')) {
      e.preventDefault(); e.stopImmediatePropagation();
      console.log('[Boopr][Addr] New address form intercepted');
      saveAddr(form.querySelector('button[type="submit"]') || form, form, 'POST', '/addresses');
      return false;
    }
    // Edit address
    var card = form.closest('.bpet-addr-card');
    if (card && form.closest('.bpet-addr-form')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var id = card.getAttribute('data-addr-id');
      console.log('[Boopr][Addr] Edit address form intercepted, id:', id);
      if (id) saveAddr(form.querySelector('button[type="submit"]') || form, form, 'PUT', '/addresses/' + id);
      return false;
    }
  }, true);
  // Delete handled by inline script in bpet-tab-addresses.liquid
  console.log('[Boopr][Addr] Standalone address handler loaded');
})();
